/* ymm.js */
/* ==========================================================
   Year / Make / Model data for the promo popup.
   Years: 2026 back to 1996 (the range the 5610 supports).
   Models cover the major US/Canada market makes; any make
   without a list (or an unlisted model) falls back to the
   "Not listed here" option that the popup appends automatically.
   ========================================================== */
window.YMM = {
  makes: [
    "Acura","Alfa Romeo","Audi","BMW","Buick","Cadillac","Chevrolet","Chrysler","Dodge","Fiat",
    "Ford","Genesis","GMC","Honda","Hummer","Hyundai","Infiniti","Isuzu","Jaguar","Jeep","Kia",
    "Land Rover","Lexus","Lincoln","Maserati","Mazda","Mercedes-Benz","Mercury","Mini","Mitsubishi",
    "Nissan","Oldsmobile","Plymouth","Pontiac","Porsche","Ram","Saab","Saturn","Scion","Subaru",
    "Suzuki","Tesla","Toyota","Volkswagen","Volvo"
  ],
  models: {
    "Acura": ["ILX","TLX","TL","TSX","RLX","RL","MDX","RDX","ZDX","Integra","NSX","CL","Legend"],
    "Alfa Romeo": ["Giulia","Stelvio","4C","Giulietta","Tonale"],
    "Audi": ["A3","A4","A4 allroad","A5","A6","A7","A8","Q3","Q5","Q7","Q8","e-tron","TT","R8","S3","S4","S5","RS 5","allroad"],
    "BMW": ["2 Series","3 Series","4 Series","5 Series","6 Series","7 Series","8 Series","X1","X2","X3","X4","X5","X6","X7","Z4","i3","i4","iX","M3","M4","M5"],
    "Buick": ["Enclave","Encore","Encore GX","Envision","LaCrosse","Regal","Verano","Lucerne","Century","LeSabre","Rendezvous","Cascada","Rainier"],
    "Cadillac": ["ATS","CTS","CT4","CT5","CT6","XTS","XT4","XT5","XT6","Escalade","SRX","DTS","STS","DeVille","Eldorado","Lyriq"],
    "Chevrolet": ["Silverado 1500","Silverado 2500HD","Colorado","Camaro","Corvette","Malibu","Impala","Cruze","Sonic","Spark","Equinox","Traverse","Tahoe","Suburban","Blazer","Trax","Trailblazer","Bolt EV","Volt","Cobalt","Aveo","HHR","Express","Avalanche","S-10","Monte Carlo"],
    "Chrysler": ["300","200","Pacifica","Town & Country","Sebring","PT Cruiser","Voyager","Aspen","Crossfire","Concorde"],
    "Dodge": ["Charger","Challenger","Durango","Journey","Grand Caravan","Dart","Avenger","Caliber","Nitro","Magnum","Neon","Stratus","Intrepid","Dakota","Viper"],
    "Fiat": ["500","500L","500X","124 Spider"],
    "Ford": ["F-150","F-250 Super Duty","F-350 Super Duty","Ranger","Maverick","Mustang","Explorer","Escape","Edge","Expedition","Bronco","Bronco Sport","Focus","Fusion","Fiesta","Taurus","Escort","Flex","EcoSport","Transit","Transit Connect","Crown Victoria","Five Hundred","Freestyle","Freestar","Windstar"],
    "Genesis": ["G70","G80","G90","GV60","GV70","GV80"],
    "GMC": ["Sierra 1500","Sierra 2500HD","Canyon","Yukon","Yukon XL","Acadia","Terrain","Savana","Envoy","Jimmy","Sonoma","Hummer EV"],
    "Honda": ["Accord","Civic","CR-V","Pilot","Odyssey","HR-V","Ridgeline","Passport","Fit","Insight","Element","CR-Z","Crosstour","S2000","Prelude","Accord Crosstour"],
    "Hummer": ["H1","H2","H3","H3T"],
    "Hyundai": ["Elantra","Sonata","Accent","Tucson","Santa Fe","Kona","Palisade","Veloster","Genesis","Azera","Ioniq","Ioniq 5","Venue","Santa Cruz","Nexo","Tiburon","Entourage","Equus","Veracruz","Santa Fe Sport"],
    "Infiniti": ["Q50","Q60","Q70","QX50","QX55","QX60","QX70","QX80","G35","G37","FX35","FX45","M35","M45","EX35","JX35","I30","QX4","QX56"],
    "Isuzu": ["Rodeo","Trooper","Ascender","i-Series","Axiom","Amigo","VehiCROSS"],
    "Jaguar": ["XE","XF","XJ","F-Type","F-Pace","E-Pace","I-Pace","S-Type","X-Type","XK"],
    "Jeep": ["Wrangler","Grand Cherokee","Cherokee","Compass","Renegade","Gladiator","Patriot","Liberty","Commander","Wagoneer","Grand Wagoneer","Grand Cherokee L"],
    "Kia": ["Optima","Forte","Rio","Soul","Sportage","Sorento","Telluride","Seltos","Stinger","Sedona","Carnival","Niro","K5","Cadenza","Spectra","Amanti","Sephia","Borrego","Rondo"],
    "Land Rover": ["Range Rover","Range Rover Sport","Range Rover Evoque","Range Rover Velar","Discovery","Discovery Sport","Defender","LR2","LR3","LR4","Freelander"],
    "Lexus": ["ES","IS","GS","LS","RC","LC","NX","RX","GX","LX","UX","CT","HS","SC","RZ","IS F"],
    "Lincoln": ["MKZ","MKS","MKX","MKC","MKT","Continental","Navigator","Aviator","Corsair","Nautilus","Town Car","LS","Zephyr","Mark LT"],
    "Maserati": ["Ghibli","Quattroporte","Levante","GranTurismo","GranCabrio","Grecale","Coupe"],
    "Mazda": ["Mazda3","Mazda6","CX-3","CX-30","CX-5","CX-9","CX-50","CX-90","MX-5 Miata","Mazda2","Tribute","CX-7","RX-8","Protege","Millenia","MPV","B-Series","MX-30"],
    "Mercedes-Benz": ["A-Class","C-Class","E-Class","S-Class","CLA","CLS","GLA","GLB","GLC","GLE","GLS","G-Class","SL","SLC","SLK","CLK","ML-Class","GL-Class","GLK-Class","Metris","Sprinter","EQS","EQE"],
    "Mercury": ["Grand Marquis","Milan","Sable","Mariner","Mountaineer","Montego","Cougar","Villager","Marauder"],
    "Mini": ["Cooper","Cooper Clubman","Cooper Countryman","Paceman","Convertible","Hardtop"],
    "Mitsubishi": ["Outlander","Outlander Sport","Eclipse Cross","Mirage","Lancer","Eclipse","Galant","Endeavor","Montero","Montero Sport","Raider","Diamante","Mirage G4"],
    "Nissan": ["Altima","Sentra","Maxima","Versa","Rogue","Rogue Sport","Murano","Pathfinder","Armada","Frontier","Titan","Kicks","Juke","Leaf","370Z","350Z","GT-R","Cube","Quest","Xterra","Ariya","Z","NV200"],
    "Oldsmobile": ["Alero","Aurora","Intrigue","Bravada","Silhouette","Cutlass","Eighty-Eight","Achieva","Regency"],
    "Plymouth": ["Neon","Breeze","Voyager","Prowler","Grand Voyager"],
    "Pontiac": ["Grand Prix","Grand Am","G6","G8","G5","G3","Vibe","Bonneville","Firebird","GTO","Solstice","Torrent","Aztek","Montana","Sunfire","Trans Sport"],
    "Porsche": ["911","718 Cayman","718 Boxster","Cayenne","Macan","Panamera","Taycan","Boxster","Cayman"],
    "Ram": ["1500","2500","3500","ProMaster","ProMaster City","Dakota"],
    "Saab": ["9-3","9-5","9-7X","9-2X","900"],
    "Saturn": ["Ion","Aura","Vue","Outlook","Sky","Relay","L-Series","S-Series"],
    "Scion": ["tC","xB","xD","xA","FR-S","iA","iM","iQ"],
    "Subaru": ["Outback","Forester","Crosstrek","Impreza","Legacy","Ascent","WRX","BRZ","Baja","Tribeca","Solterra","SVX"],
    "Suzuki": ["Grand Vitara","SX4","Kizashi","Forenza","Aerio","XL-7","Reno","Verona","Equator","Vitara","Esteem"],
    "Tesla": ["Model 3","Model S","Model X","Model Y","Roadster","Cybertruck"],
    "Toyota": ["Camry","Corolla","Prius","RAV4","Highlander","4Runner","Tacoma","Tundra","Sienna","Sequoia","Avalon","Yaris","C-HR","Venza","Land Cruiser","Supra","86","GR86","GR Corolla","Matrix","Solara","FJ Cruiser","Echo","bZ4X","Corolla Cross","Prius Prime"],
    "Volkswagen": ["Jetta","Passat","Golf","GTI","Golf R","Tiguan","Atlas","Atlas Cross Sport","Beetle","Arteon","Taos","ID.4","Touareg","CC","Eos","Rabbit","Routan","GLI"],
    "Volvo": ["S60","S90","V60","V90","XC40","XC60","XC90","S40","S80","V50","V70","C30","C70","XC70"]
  }
};


/* script-switch.js */
/* ==========================================================
   INNOVA 5610 — interactions present in the design
   ========================================================== */
(function () {
  'use strict';

  /* ---------- star ratings ---------- */
  var STAR = 'M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5 7.3 14.03 2.6 9.45l6.5-.95z';
  document.querySelectorAll('[data-stars]').forEach(function (el) {
    var v = parseFloat(el.getAttribute('data-stars')) || 5, html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = v >= i ? 1 : (v > i - 1 ? v - (i - 1) : 0);
      if (fill === 1) {
        html += '<svg viewBox="0 0 24 24"><path d="' + STAR + '"/></svg>';
      } else if (fill === 0) {
        html += '<svg viewBox="0 0 24 24" style="fill:#c9c9c9"><path d="' + STAR + '"/></svg>';
      } else {
        var id = 'g' + Math.random().toString(36).slice(2, 8);
        html += '<svg viewBox="0 0 24 24"><defs><linearGradient id="' + id + '">' +
          '<stop offset="' + (fill * 100) + '%" stop-color="currentColor"/>' +
          '<stop offset="' + (fill * 100) + '%" stop-color="#c9c9c9"/></linearGradient></defs>' +
          '<path d="' + STAR + '" fill="url(#' + id + ')"/></svg>';
      }
    }
    el.innerHTML = html;
  });

  /* ---------- hero: rotate the truck and the two cars ----------
     The truck (slide 1) keeps its one-time headlight ignition, so the first hold covers that 3s
     timeline plus a lit beat. After that each photo holds 5s and crossfades in on top of the last.
     Waits for a photo to finish loading rather than fading in a blank, pauses while the tab is
     hidden, and stays on the truck for visitors who have asked for reduced motion. */
  (function () {
    var slides = document.querySelectorAll('#heroMedia .hero-slide');
    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var FIRST_HOLD = 4500, HOLD = 5000, FADE = 1200;
    var cur = 0, timer = null;
    var ready = function (el) {
      var img = el.tagName === 'IMG' ? el : el.querySelector('img');
      return !img || (img.complete && img.naturalWidth > 0);
    };
    var advance = function () {
      var next = (cur + 1) % slides.length;
      if (!ready(slides[next])) { timer = setTimeout(advance, 1000); return; }
      var prev = slides[cur];
      cur = next;
      prev.classList.remove('is-on');
      prev.classList.add('was-on');            // stays opaque underneath while the next fades in
      slides[cur].classList.remove('was-on');
      slides[cur].classList.add('is-on');
      setTimeout(function () { prev.classList.remove('was-on'); }, FADE + 100);
      timer = setTimeout(advance, HOLD);
    };
    timer = setTimeout(advance, FIRST_HOLD);
    document.addEventListener('visibilitychange', function () {
      clearTimeout(timer);
      if (!document.hidden) timer = setTimeout(advance, HOLD);
    });
  })();

  /* ---------- hero video: play once, then settle on the product still ---------- */
  var heroVideo = document.getElementById('heroVideo');
  var heroMedia = document.getElementById('heroMedia');
  if (heroVideo) {
    heroVideo.loop = false;
    heroVideo.addEventListener('ended', function () {
      heroVideo.pause();
      if (heroMedia) heroMedia.classList.add('ended'); // fade in High-Res still
    });
  }

  /* ---------- reviews carousel (Scotty + testimonials) ---------- */
  var rstage = document.getElementById('rstage');
  var rdots = document.getElementById('rdots');
  if (rstage && rdots) {
    var slides = rstage.querySelectorAll('.rslide');
    var dots = rdots.querySelectorAll('i');
    var show = function (n) {
      slides.forEach(function (s, i) { s.classList.toggle('on', i === n); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === n); });
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
  }

  /* ---------- "Speak your car's language" expanding gallery ---------- */
  var cards = document.getElementById('cards');
  if (cards) {
    var items = cards.querySelectorAll('.c');
    items.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('open')) return;   // only one open at a time
        items.forEach(function (x) { x.classList.remove('open'); });
        c.classList.add('open');
      });
    });
  }

  /* ---------- product gallery thumbnails ---------- */
  var thumbs = document.getElementById('galThumbs');
  if (thumbs) {
    var main = document.getElementById('galMain'), firstThumb = thumbs.querySelector('button');
    thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        main.src = b.getAttribute('data-src');
        main.parentNode.classList.toggle('is-alt', b !== firstThumb);   // the offer line belongs to the first photo only
      });
    });
  }

  /* ---------- purchase options ---------- */
  var opts = document.getElementById('opts');
  if (opts) {
    var labels = opts.querySelectorAll('.opt');
    labels.forEach(function (l) {
      l.addEventListener('click', function () {
        labels.forEach(function (x) { x.classList.remove('on'); });
        l.classList.add('on');
        l.querySelector('input').checked = true;
      });
    });
  }

  /* ---------- awards: duplicate items for the seamless mobile marquee ---------- */
  var awTrack = document.querySelector('.awards .aw-track');
  if (awTrack) {
    awTrack.querySelectorAll('.aw').forEach(function (aw) {
      var c = aw.cloneNode(true);
      c.classList.add('aw-clone');
      c.setAttribute('aria-hidden', 'true');
      awTrack.appendChild(c);
    });
  }

  /* ---------- live-data pulse: build a repeating ECG waveform ---------- */
  (function () {
    var svg = document.querySelector('.pulse-svg');
    if (!svg) return;
    var W = 1200, mid = 100, beats = 4, seg = W / beats, d = 'M0 ' + mid;
    for (var i = 0; i < beats; i++) {
      var x = i * seg;
      d += ' L' + (x + seg * 0.42) + ' ' + mid;                                   // flat
      d += ' Q' + (x + seg * 0.48) + ' ' + (mid - 14) + ' ' + (x + seg * 0.54) + ' ' + mid; // P wave
      d += ' L' + (x + seg * 0.58) + ' ' + mid;
      d += ' L' + (x + seg * 0.60) + ' ' + (mid + 18);                            // Q
      d += ' L' + (x + seg * 0.63) + ' ' + (mid - 70);                            // R spike
      d += ' L' + (x + seg * 0.66) + ' ' + (mid + 34);                            // S
      d += ' L' + (x + seg * 0.69) + ' ' + mid;
      d += ' Q' + (x + seg * 0.80) + ' ' + (mid - 22) + ' ' + (x + seg * 0.88) + ' ' + mid; // T wave
      d += ' L' + (x + seg) + ' ' + mid;
    }
    svg.querySelectorAll('path').forEach(function (p) { p.setAttribute('d', d); });
  })();

  /* ---------- "does it work on my car?" fit checker ---------- */
  (function () {
    var toggle = document.getElementById('fitToggle');
    var panel = document.getElementById('fitPanel');
    var yearSel = document.getElementById('fitYear');
    var makeSel = document.getElementById('fitMake');
    var modelSel = document.getElementById('fitModel');
    var result = document.getElementById('fitResult');
    var resultHead = document.querySelector('.fit-result b');
    var resultText = document.getElementById('fitResultText');
    if (!toggle || !panel || !yearSel || !window.YMM) return;

    // keep the promise honest: exclude EV-only brand, EVs, and heavy-duty / commercial models
    var EX_MAKES = { 'Tesla': 1 };
    // brands with no OBD1-era (pre-1996) US presence — hidden when an older year is picked
    var EX_MAKES_PRE96 = { 'Genesis': 1, 'Scion': 1, 'Mini': 1, 'Ram': 1, 'Fiat': 1, 'Kia': 1,
      'Alfa Romeo': 1, 'Maserati': 1, 'Hummer': 1 };
    var EX_MODELS = {};
    ['e-tron', 'i3', 'i4', 'iX', 'Bolt EV', 'Lyriq', 'Ioniq 5', 'Nexo', 'I-Pace', 'EQS', 'EQE', 'Leaf',
     'Ariya', 'Taycan', 'Solterra', 'bZ4X', 'ID.4', 'RZ', 'GV60', 'Hummer EV', 'H1',
     'F-250 Super Duty', 'F-350 Super Duty', 'Silverado 2500HD', 'Sierra 2500HD', '2500', '3500',
     'ProMaster', 'ProMaster City', 'Express', 'Savana', 'Sprinter', 'Transit', 'Transit Connect',
     'Metris', 'NV200'].forEach(function (m) { EX_MODELS[m] = 1; });

    var HEADERS = ['Nice choice!', "That's a nice ride.", 'Great taste!', 'Solid pick.', 'Ooh, good one.'];
    var headIdx = 0;

    var opt = function (sel, label, value) {
      var o = document.createElement('option');
      o.textContent = label; o.value = (value === undefined ? label : value);
      sel.appendChild(o); return o;
    };
    var isPre96 = function () { var y = parseInt(yearSel.value, 10); return !!y && y <= 1995; };

    // Years: 2026 shown as "coming soon" (disabled), selectable 2025 down to 1990 (OBD1 era)
    yearSel.innerHTML = '<option value="" selected disabled>Year</option>';
    var soon = opt(yearSel, '2026 (Coming soon)', ''); soon.disabled = true;
    for (var y = 2025; y >= 1990; y--) opt(yearSel, String(y));

    var fillMakes = function () {
      var cur = makeSel.value, pre = isPre96();
      makeSel.innerHTML = '<option value="" selected disabled>Make</option>';
      window.YMM.makes.forEach(function (m) {
        if (EX_MAKES[m]) return;
        if (pre && EX_MAKES_PRE96[m]) return;
        opt(makeSel, m);
      });
      if (cur) { makeSel.value = cur; if (makeSel.value !== cur) makeSel.selectedIndex = 0; }
    };
    var fillModels = function () {
      var cur = modelSel.value;
      modelSel.innerHTML = '<option value="" selected disabled>Model</option>';
      (window.YMM.models[makeSel.value] || []).forEach(function (m) { if (!EX_MODELS[m]) opt(modelSel, m); });
      modelSel.disabled = !makeSel.value;
      if (cur) { modelSel.value = cur; if (modelSel.value !== cur) modelSel.selectedIndex = 0; }
    };
    var showResult = function () {
      if (yearSel.value && makeSel.value && modelSel.value) {
        resultHead.textContent = HEADERS[headIdx % HEADERS.length]; headIdx++;
        var msg = 'The Innova 5610 works with your ' + yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value + '.';
        if (isPre96()) msg += ' Just add a separate OBD1 adapter (available at innova.com).';
        resultText.textContent = msg;
        result.hidden = false;
      } else {
        result.hidden = true;
      }
    };

    yearSel.addEventListener('change', function () { fillMakes(); fillModels(); showResult(); });
    makeSel.addEventListener('change', function () { fillModels(); showResult(); });
    modelSel.addEventListener('change', showResult);
    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
    });

    // clean state on load / bfcache restore (don't let the browser keep a stale result showing)
    var reset = function () {
      yearSel.selectedIndex = 0;
      fillMakes(); makeSel.selectedIndex = 0;
      modelSel.innerHTML = '<option value="" selected disabled>Model</option>'; modelSel.disabled = true;
      result.hidden = true;
      panel.hidden = true; toggle.setAttribute('aria-expanded', 'false');
    };
    reset();
    window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
  })();

  /* ---------- accordions (buy box + FAQ) ---------- */
  function accordion(root) {
    if (!root) return;
    root.querySelectorAll('.it').forEach(function (item) {
      var q = item.querySelector('.q'), a = item.querySelector('.a');
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.it.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.a').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  accordion(document.getElementById('acc'));
  accordion(document.getElementById('faq'));

  /* ---------- countdown ---------- */
  var timer = document.getElementById('timer');
  if (timer) {
    var KEY = 'innova5610_deadline';
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    var now = Date.now();
    if (!deadline || deadline < now || deadline - now > 7 * 3600 * 1000) {
      deadline = now + 5 * 3600 * 1000 + 2 * 60 * 1000 + 45 * 1000;
      localStorage.setItem(KEY, String(deadline));
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var d = Math.max(0, deadline - Date.now());
      timer.textContent = Math.floor(d / 3600000) + ':' +
        pad(Math.floor((d % 3600000) / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- modals (features + 3360 camera) ---------- */
  function wireModal(modal, openBtn) {
    if (!modal) return;
    var open = function () {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      modal.querySelectorAll('video').forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    };
    var close = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
    };
    if (openBtn) {
      if (openBtn.forEach) openBtn.forEach(function (b) { if (b) b.addEventListener('click', open); });
      else openBtn.addEventListener('click', open);
    }
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  }
  wireModal(document.getElementById('featModal'), document.querySelectorAll('.js-feat-open'));
  wireModal(document.getElementById('cam3360Modal'), [document.getElementById('cam3360Open'), document.querySelector('[data-gift-info="3360"]')]);
  wireModal(document.getElementById('gift3380Modal'), document.querySelectorAll('[data-gift-info="3380"]'));
  wireModal(document.getElementById('giftCarmdModal'), document.querySelectorAll('[data-gift-info="carmd"]'));

  /* ---------- influencer videos: tap to unmute (one at a time) ---------- */
  (function () {
    var figs = [].slice.call(document.querySelectorAll('.infl'));
    if (!figs.length) return;
    figs.forEach(function (fig) {
      var vid = fig.querySelector('video');
      var btn = fig.querySelector('.infl-sound');
      if (!vid) return;
      var toggle = function (e) {
        if (e) e.preventDefault();
        var turnOn = vid.muted;
        figs.forEach(function (f) {
          var v = f.querySelector('video');
          if (v) v.muted = true;
          f.classList.remove('on');
        });
        if (turnOn) {
          vid.muted = false;
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
          fig.classList.add('on');
        }
      };
      if (btn) btn.addEventListener('click', toggle);
      vid.addEventListener('click', toggle);
    });
  })();

  /* ---------- scarcity: live stock counter ---------- */
  var stockLeft = document.getElementById('stockLeft');
  var scarFill = document.getElementById('scarFill');
  if (stockLeft && scarFill) {
    var pct = 4; // % of the bundle left
    var render = function () {
      stockLeft.textContent = pct + '%';
      scarFill.style.width = pct + '%';          // the red bar is the stock that is LEFT
    };
    render();
    setInterval(function () {
      if (pct > 2 && Math.random() < 0.55) {
        pct = Math.max(2, Math.round((pct - (Math.random() * 0.3 + 0.1)) * 10) / 10);
        render();
      }
    }, 8000);
  }

  /* ---------- delivery date: 2 days ahead (PST) ---------- */
  var deliveryEl = document.getElementById('deliveryDate');
  if (deliveryEl) {
    try {
      var future = new Date(Date.now() + 2 * 86400000);
      deliveryEl.textContent = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles', weekday: 'long', month: 'long', day: 'numeric'
      }).format(future);
    } catch (e) { /* leave fallback text */ }
  }

  /* ---------- checkout: slide-in cart, then the pre-filled cart URL ---------- */
  var CART_BASE = 'https://www.innova.com/cart/32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1,39553005617198:1?discount=5610_BOGO3360_PARTNER,5610_PARTNERSHIPS_FP';
  var CART_EMAIL = CART_BASE + ',CRX2000';
  // sale cart: no 3360 camera variant; 5610_PARTNERSHIP + 5610_PARTNERSHIPS_FP bring it to $269
  var SALE_CART = 'https://www.innova.com/cart/32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1?discount=5610_PARTNERSHIP,5610_PARTNERSHIPS_FP';
  /* ---------- 2026 holiday offer: ONE free gift of the visitor's choice + a $20 gift card ----------
     From 12:01 AM Pacific on Oct 8 until the end of Dec 31 the bundle swaps the 3360 for one gift the
     visitor picks, plus a $20 Innova gift card. The offer stays the same; only the wording follows the
     season. Times are Pacific wall clock "YYYY-MM-DD HH:MM", start inclusive, end exclusive.
     Preview any phase with ?phase=prebf|bf|cm|xmas (or ?phase=off), preselect with ?gift=3360|3380|carmd.
     Each gift has its own code, paired with 5610_PARTNERSHIPS_GIFTCARD (boot, app, shipping, gift card). Outside the
     window everything below falls back to CART_BASE / CART_EMAIL, the everyday camera bundle. */
  /* Each season also has its own look (colours and decoration only, the wording is untouched):
     body.themed + body.theme-<key> switch on that season's block at the end of style-d.css. A phase
     can borrow another season's look with theme: '<key>'. false here = seasonal wording only.
     ?theme=off previews a season without its look. */
  var HOLIDAY_THEMES = true;
  var HOLIDAY_PHASES = [
    // The user, Nov 2 2026: "start the black friday starting Nov 6 till CM, then CM change to CM, and then change to Christmas.
    // automatically". Cyber Monday 2026 is Nov 30 (it was set to Dec 1, last year's date). carmd: CarMD Connect can be the
    // gift, before Nov 6 only ("After Nov 6, kill all CarMD offers and mentions"). gift: the one picked at first, the 3360
    // ("keep the price at $349 with the freebie (3360) selected"), the 3380 while the 3360 is sold out.
    { key: 'prebf', from: '2026-10-08 00:01', to: '2026-11-06 00:00', lead: 'PRE-BLACK FRIDAY', badge: 'Pre-Black Friday', pick: 'Your Pre-Black Friday gift: pick one', carmd: true },
    { key: 'bf',    from: '2026-11-06 00:00', to: '2026-11-30 00:00', lead: 'BLACK FRIDAY',     badge: 'Black Friday',     pick: 'Your Black Friday gift: pick one', gift: '3360' },
    { key: 'cm',    from: '2026-11-30 00:00', to: '2026-12-01 00:00', lead: 'CYBER MONDAY',     badge: 'Cyber Monday',     pick: 'Your Cyber Monday gift: pick one', gift: '3360' },
    { key: 'xmas',  from: '2026-12-01 00:00', to: '2027-01-01 00:00', lead: 'CHRISTMAS SALE',   badge: 'Christmas Sale',   pick: 'Your Christmas gift: pick one', gift: '3360' }
  ];
  /* qty: how many of the gift go in the cart (1 if not given); freebies: the code that frees the boot, app,
     shipping and gift card alongside this gift's own code (HOLIDAY_FREEBIES_CODE if not given).
     CarMD Connect comes as two from Oct 23, 2026 (the user: "update the offer so that it gives 2 CarMD
     dongles"), with the user's own link and codes: 5610_BOGO_2CarMD frees both, 5610DEAL0 the rest.
     promo: false would leave the scratch card's CRX2000 out of a gift's link. It was on CarMD Connect from Oct 23
     to Oct 26, 2026, while checkout dropped CRX2000 next to these two codes; the user then let them combine with
     order discounts, CRX2000 takes its $20 off with them (checked at checkout), and the flag and the popup's note
     came out. */
  var GIFTS = {
    // listed in the picker's order: CarMD Connect first, and the default pick (the user's call, Oct 13 2026)
    'carmd': { variant: '42744886525998', qty: 2, code: '5610_BOGO_2CarMD', freebies: '5610DEAL0', value: 200, name: '2\u00d7 CarMD Connect', cartName: 'CarMD Connect \u00d72' },
    '3360':  { variant: '39553005617198', code: '5610_BOGO3360_PARTNER', value: 200, name: 'Innova 3360 Thermal Camera',    cartName: 'Innova 3360 Camera' },
    '3380':  { variant: '32538802585646', code: '5610_BOGO3380',  value: 99,  name: 'Innova 3380 Inspection Camera', cartName: 'Innova 3380 Camera' }
  };
  // Shopify product handles, for the live stock check in the picker (a sold-out gift is hidden)
  var GIFT_HANDLES = { '3360': 'innova-multi-purpose-infrared-inspection-camera-3360', '3380': '3380-inspection-camera', 'carmd': 'carmd-connect' };
  var noCamera = false;   // everyday offer only: true once Shopify says the 3360 is sold out
  /* Ask Shopify's public product JSON whether each gift's variant is still for sale ("available" turns
     false once a tracked item hits zero and can't be oversold). It answers any origin, so this also works
     on Railway. done(avail) gets avail[key] === false for a sold-out gift; a failed or slow check (5s)
     leaves the key unset, which callers treat as in stock, so a hiccup can never blank the offer.
     ?soldout=3360,carmd pretends those gifts are sold out, to preview the fallbacks. */
  var checkStock = function (keys, done) {
    if (!window.fetch) return;
    var avail = {}, pending = keys.length;
    var forced = ((location.search.match(/[?&]soldout=([a-z0-9,]+)/) || [])[1] || '').split(',');
    var base = /(^|\.)innova\.com$/.test(location.hostname) ? '' : 'https://www.innova.com';
    var settle = function () { if (!--pending) done(avail); };
    keys.forEach(function (k) {
      if (forced.indexOf(k) > -1) { avail[k] = false; settle(); return; }
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
      fetch(base + '/products/' + GIFT_HANDLES[k] + '.js', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          var v = p.variants.filter(function (x) { return String(x.id) === GIFTS[k].variant; })[0];
          avail[k] = v ? !!v.available : !!p.available;
        })
        .catch(function () {})
        .then(function () { clearTimeout(timer); settle(); });
    });
  };
  var GIFT_CARD_VARIANT = '41613976174638', GIFT_CARD_VALUE = 20, BUNDLE_PRICE = 349;   // $20 Innova Digital Gift Card
  /* ---------- the email price (the user, Oct 27 2026: "that same email and $50 discount", as on the bundle page) ----------
     Until the end of Nov 5, 2026 (Pacific; it was Nov 11, the user's call of Oct 27, until CarMD Connect, its only gift, went
     on Nov 6), a visitor who gives their email in the box above
     Claim Offer (or in its copy in the repeated offer) gets the 5610 for $299: the page's prices drop by $50 and the gift
     link carries code, the $50 order discount the user made for the bundle page. Only with the 2x CarMD Connect gift
     (mailGift, below). Same Klaviyo list; the address is kept under the same key as
     on the bundle page, so one signup holds on both. Not during a flash sale (cheaper, and the two must never stack);
     and it takes the place of the scratch card's CRX2000 in the link ($50 rather than $20, never both). After the end
     the box goes and everything is as before. Preview: ?maildeal=on|off, ?maildeal=done (unlocked, nothing sent). */
  var MAIL_DEAL = { until: '2026-11-06 00:00', price: 299, code: '5610_EMAIL_299', klaviyoKey: 'T9Ldwz', list: 'W4KGjy', store: 'innova_bundle_email_299' };
  var mailOpen = (function () {
    var forced = (location.search.match(/[?&]maildeal=(on|off|done)\b/) || [])[1];
    if (forced) return forced !== 'off';
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      return (g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute) < MAIL_DEAL.until;
    } catch (e) { return false; }
  })();
  var mailEmail = null;
  if (mailOpen) { try { mailEmail = localStorage.getItem(MAIL_DEAL.store); } catch (e) {} }
  if (/[?&]maildeal=done\b/.test(location.search)) mailEmail = 'preview';
  /* only with the 2x CarMD Connect gift (the user, Nov 2 2026: "when they switch to 3360 or 3380, remove the email coupon
     option so the price remains at $349"): with either camera picked the box and the lock go, the price is $349 and the
     code stays out of the link (a popup signup's CRX2000 comes back); CarMD Connect picked again brings $299 back to a
     visitor who already gave their email. mailSync, called from renderGift, keeps the page's classes in step. */
  var mailGift = function () { return !!holiday && giftKey === 'carmd'; };
  var mailOn = function () { return mailOpen && !!mailEmail && !saleActive && mailGift(); };
  var mailSync = function () {
    var show = mailOpen && mailGift() && !!document.getElementById('mailDeal');
    document.body.classList.toggle('mail-run', mailOpen && !!holiday && !!document.getElementById('mailDeal'));   // the note under the picker
    document.body.classList.toggle('mail-open', show);                  // the box and the lock
    document.body.classList.toggle('mail-on', show && !!mailEmail);     // unlocked: $299
  };
  // the $299 week (PRICE_DROP, below) or an unlocked email price; never both (they are the same code)
  var bundlePrice = function () { return dropOn ? PRICE_DROP.price : mailOn() ? MAIL_DEAL.price : BUNDLE_PRICE; };
  var withMailCode = function (url) {
    var code = dropOn ? PRICE_DROP.code : mailOn() ? MAIL_DEAL.code : '';
    return code ? url + (url.indexOf('?') < 0 ? '?discount=' : ',') + code : url;
  };
  /* In the holiday links 5610_PARTNERSHIPS_GIFTCARD takes the place of 5610_PARTNERSHIPS_FP: the same free
     boot, app and shipping, plus the $20 gift card, in one code (so it stacks with each gift's code the
     way _FP does). The everyday and flash-sale links keep _FP, so the gift card is only ever added from
     Oct 8. Checked at innova.com checkout with all three gifts and with CRX2000. */
  var HOLIDAY_FREEBIES_CODE = '5610_PARTNERSHIPS_GIFTCARD';
  var BUNDLE_ITEMS = '32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1';  // 5610, boot, shipping, app
  var holiday = (function () {
    var forced = (location.search.match(/[?&]phase=([a-z]+)/) || [])[1];
    if (forced === 'off') return null;
    var i, now;
    for (i = 0; i < HOLIDAY_PHASES.length; i++) if (HOLIDAY_PHASES[i].key === forced) return HOLIDAY_PHASES[i];
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      now = g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
    } catch (e) { return null; }
    for (i = 0; i < HOLIDAY_PHASES.length; i++) {
      if (HOLIDAY_PHASES[i].from <= now && now < HOLIDAY_PHASES[i].to) return HOLIDAY_PHASES[i];
    }
    return null;
  })();
  /* CarMD Connect is a gift only before Nov 6 (holiday.carmd, above). From then on it leaves GIFTS, so the picker, the stock
     check, the links and everything that names the picked gift go without it; its card leaves the picker and the page
     carries no-carmd (no CarMD Connect section). */
  var carmdOn = !!holiday && !!holiday.carmd;
  if (!carmdOn) delete GIFTS.carmd;
  var giftKey = (location.search.match(/[?&]gift=(3360|3380|carmd)\b/) || [])[1];
  if (!GIFTS[giftKey]) giftKey = (holiday && holiday.gift) || (carmdOn ? 'carmd' : '3360');
  /* ---------- Black Friday week at $299 (the user, Nov 2 2026: "From Nov 26-30, still offer the freebie but drop the price
     to $299") ----------
     From 12:00 AM Pacific on Nov 26 to the end of Nov 30 the gift bundle costs $299 for everyone: every price on the page
     reads $299 and every gift link carries code, a $50 order discount (5610_EMAIL_299, made for the email price; it combines
     with the gift codes, and Shopify has to keep it valid until Nov 30 11:59 PM). The scratch card's CRX2000 stays out of the
     links and its popup and prize tab stay away meanwhile, so its $20 never stacks on it. A flash sale still leads with
     its own price. Preview: ?pricedrop=on|off. */
  var PRICE_DROP = { from: '2026-11-26 00:00', to: '2026-12-01 00:00', price: 299, code: '5610_EMAIL_299' };
  var dropOn = !!holiday && (function () {
    var forced = (location.search.match(/[?&]pricedrop=(on|off)\b/) || [])[1];
    if (forced) return forced === 'on';
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      var now = g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
      return PRICE_DROP.from <= now && now < PRICE_DROP.to;
    } catch (e) { return false; }
  })();
  if (dropOn) document.body.classList.add('drop-on');     // hides Shop Pay's installments line, worked out from $349.99
  /* the cart link for the bundle as it stands: the picked gift + gift card with that gift's own code
     during the holiday window, the everyday camera bundle otherwise. withEmail (default: whether the
     visitor already gave us their email) adds the CRX2000 $20-off code. */
  var bundleCart = function (withEmail) {
    if (withEmail === undefined) withEmail = emailCaptured;
    if (mailOn() || dropOn) withEmail = false;   // the $50 email price, or the $299 week, takes the place of CRX2000's $20
    if (!holiday) {
      // everyday offer; with the 3360 sold out it carries on without the camera and without its code
      if (noCamera) return withMailCode('https://www.innova.com/cart/' + BUNDLE_ITEMS + '?discount=5610_PARTNERSHIPS_FP' + (withEmail ? ',CRX2000' : ''));
      return withMailCode(withEmail ? CART_EMAIL : CART_BASE);
    }
    var g = giftKey ? GIFTS[giftKey] : null;    // null only if every gift is sold out: gift card only
    return withMailCode('https://www.innova.com/cart/' + BUNDLE_ITEMS + (g ? ',' + g.variant + ':' + (g.qty || 1) : '') + ',' + GIFT_CARD_VARIANT + ':1' +
      '?discount=' + (g ? g.code + ',' : '') + ((g && g.freebies) || HOLIDAY_FREEBIES_CODE) + (withEmail && !(g && g.promo === false) ? ',CRX2000' : ''));
  };
  /* InnovaCare+ protection plan: opt-in, off by default. The variant is spliced into
     whichever cart URL is current, so that state's own discount is preserved verbatim. */
  var CARE_VARIANT = '42329280643118:1';
  var CARE_PRICE = 39;
  var careOn = false;
  var careRowEl = document.getElementById('careRow');
  var careToggleEl = document.getElementById('careToggle');
  var crowCare = document.getElementById('crowCare');
  var cartCountEl = document.getElementById('cartCount');
  var withCare = function (url) {
    if (!careOn) return url;
    var qi = url.indexOf('?');
    return qi < 0 ? url + ',' + CARE_VARIANT
                  : url.slice(0, qi) + ',' + CARE_VARIANT + url.slice(qi);
  };
  var cartGo = document.getElementById('cartGo');
  var crowEmail = document.getElementById('crowEmail');
  var cartTotal = document.getElementById('cartTotal');

  var saleActive = false, salePriceStr = '$269', promoActive = false, promoCfg = null;
  var lastCartUrl = null;
  /* Other apps can add their own parameters to our cart links after the page loads: Intelligems
     appends attributes[igId]=... so the order is credited to the visitor's test group. Every later
     rewrite (a gift pick, InnovaCare+, the email code, the flash toggle) would wipe it, so carry over
     anything that isn't ours (discount, payment) from the link being replaced. */
  var keepExtras = function (oldHref, url) {
    var q = (oldHref && oldHref.indexOf('/cart/') > -1 && oldHref.split('?')[1]) || '';
    var extras = q.split('&').filter(function (p) { return p && !/^(discount|payment)=/i.test(p); });
    return extras.length ? url + (url.indexOf('?') < 0 ? '?' : '&') + extras.join('&') : url;
  };
  var setCheckout = function (url) {
    lastCartUrl = url;                                 // remembered so the add-on can re-apply
    var withEmail = !saleActive && url.indexOf('CRX2000') > -1;
    var target = withCare(url);
    // real navigation targets (also the JS-disabled fallback for anchor triggers)
    document.querySelectorAll('.js-checkout').forEach(function (a) { if (a.tagName === 'A') a.setAttribute('href', keepExtras(a.getAttribute('href'), target)); });
    if (cartGo) cartGo.setAttribute('href', keepExtras(cartGo.getAttribute('href'), target));
    if (crowEmail) crowEmail.hidden = !withEmail;      // CRX2000 line only when email captured AND not on sale
    if (crowCare) crowCare.hidden = !careOn;
    var withMail = !saleActive && (url.indexOf(MAIL_DEAL.code) > -1 || url.indexOf(PRICE_DROP.code) > -1);
    var base = saleActive ? (parseInt(String(salePriceStr).replace(/[^0-9]/g, ''), 10) || 0)
                          : withMail ? bundlePrice() : (withEmail ? 329 : 349);
    if (cartTotal) cartTotal.textContent = '$' + (base + (careOn ? CARE_PRICE : 0));
    if (cartCountEl) {
      var n = 0;
      document.querySelectorAll('.cart-body .citem').forEach(function (el) {
        if (getComputedStyle(el).display !== 'none') n++;
      });
      if (careOn) n++;
      cartCountEl.textContent = n + ' item' + (n === 1 ? '' : 's');
    }
  };
  if (careToggleEl) {
    careToggleEl.addEventListener('click', function () {
      careOn = !careOn;
      if (careRowEl) careRowEl.classList.add('hinted');   // stop nudging once they have engaged
      careToggleEl.setAttribute('aria-checked', String(careOn));
      if (careRowEl) careRowEl.classList.toggle('on', careOn);
      setCheckout(lastCartUrl || bundleCart());        // re-apply against the live cart state
    });
  }
  var emailCaptured = false;
  try { emailCaptured = !!localStorage.getItem('innova_email_captured'); } catch (e) {}
  setCheckout(bundleCart());

  /* ---------- Shop Pay Installments modal: check out with the whole bundle ----------
     Shopify's "Continue to checkout" button builds /cart/<5610 variant>:1 by itself, so the
     free case, app, shipping, camera and discount codes all drop off. Catch the click in the
     capture phase, before Shopify's own handler runs, and send it to the same cart link the
     rest of the page uses, so whichever offer the visitor picked comes through intact,
     including the InnovaCare+ plan when it is switched on (cartGo already carries it).
     The modal lives in an open shadow root, which composedPath() can see into. If Shopify
     ever renames the hook, nothing matches and their default behaviour simply returns. */
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var hit = path.some(function (n) {
      return n && n.getAttribute && n.getAttribute('data-testid') === 'sample-plans-modal-continue-to-checkout-button';
    });
    if (!hit || !cartGo) return;
    var url = cartGo.getAttribute('href');
    if (!url || url === '#') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // payment=shop_pay_installments is the parameter Shopify's own button adds: it opens Shop Pay
    // with installments selected. Checked that both offers keep every free item and discount code
    // through that handoff. Only this modal button uses it; the page's main CTA stays on the
    // regular checkout so shoppers paying in full are not routed through a Shop Pay sign-in.
    window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + 'payment=shop_pay_installments';
  }, true);

  /* ---------- scheduled sale mode (driven by a Google Sheet, times in PST) ---------- */
  /* SETUP: make a sheet with headers  Start (PST) | End (PST) | Price | 3360 Camera
     Start/End = "YYYY-MM-DD HH:MM" Pacific (e.g. 2026-08-01 00:00). Price = e.g. 269.
     3360 Camera = "No" to drop the free camera (default is to drop it during any sale).
     File -> Share -> Publish to web -> CSV, then paste that link below. */
  var SALE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR8_-VBtZsinlLkdfa5JdAKT7_27Y0l839zMT_yXsD5qtTwCpcxBcQN0yfgjeZ_Hg5opfnYmNfFUDrb/pub?output=csv';
  var MSRP = 549, F_CAM = 200, F_BOOT = 20, F_APP = 99, F_SHIP = 10;

  var applySale = function (cfg) {
    saleActive = true;
    var price = cfg.price, keepCam = !!cfg.camera && !noCamera;
    salePriceStr = '$' + price;
    var value = MSRP + (keepCam ? (holiday ? (giftKey ? GIFTS[giftKey].value : 0) + GIFT_CARD_VALUE : F_CAM) : 0) + F_BOOT + F_APP + F_SHIP;
    var save = value - price, pct = Math.round(save / value * 100), off = MSRP - price;
    document.body.classList.add('sale-mode');
    var set = function (id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; };
    set('barMsg', 'FLASH SALE: Get $' + off + ' OFF — the Innova 5610 is now just $' + price);
    set('dealBadge', 'FLASH SALE');
    // Flash deal is the lowest cash price, not a bigger % than the camera bundle (both ~60% of their
    // own value), so lead with "Best price" here and keep the concrete $ in the "You save" button.
    set('dealPill', 'Best price');
    set('dealScanPrice', '<s>$' + MSRP + '</s> $' + price);
    set('dealPrice', '$' + price);
    set('dealValue', '$' + value + ' total value');
    set('dealSave', 'You save $' + save + ' &rarr;');
    set('vsCost', '$' + price);
    set('cmpPrice', '<s>$' + MSRP + '</s> $' + price);
    set('cartCount', (keepCam ? 5 : 4) + ' items');
    set('cartSaveText', '$' + save + ' · best price');
    set('cartScanPrice', '$' + price);
    set('cartRetail', '$' + value);
    set('cartDiscount', '−$' + save);
    setCheckout(keepCam ? bundleCart(false) : SALE_CART);
  };

  /* ---------- announcement-bar phrase: auto-swap the lead on holiday weekends (Pacific) ---------- */
  /* Only the words before the first colon change (e.g. "SPECIAL OFFER" -> "LABOR DAY SALE"); the rest
     of the banner is untouched. Rule-based dates = no yearly upkeep. A live flash sale still overrides
     this via applySale(). Runs BEFORE the NORMAL capture so the toggle restores the holiday phrase. */
  (function () {
    var barMsgEl = document.getElementById('barMsg');
    if (!barMsgEl) return;
    var addDays = function (d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); };
    var nthWeekday = function (y, m, wd, n) { var d = new Date(y, m, 1); var s = (wd - d.getDay() + 7) % 7; return new Date(y, m, 1 + s + (n - 1) * 7); };
    var lastWeekday = function (y, m, wd) { var d = new Date(y, m + 1, 0); var s = (d.getDay() - wd + 7) % 7; return addDays(d, -s); };
    var windowsFor = function (Y) {
      var tg = nthWeekday(Y, 10, 4, 4); // Thanksgiving = 4th Thursday of November
      return [
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 0, 1),   end: new Date(Y, 0, 1) },
        { lead: "PRESIDENTS' DAY SALE", start: addDays(nthWeekday(Y, 1, 1, 3), -3), end: nthWeekday(Y, 1, 1, 3) },
        { lead: 'MEMORIAL DAY SALE',    start: addDays(lastWeekday(Y, 4, 1), -3), end: lastWeekday(Y, 4, 1) },
        { lead: '4TH OF JULY SALE',     start: new Date(Y, 6, 1),   end: new Date(Y, 6, 5) },
        { lead: 'LABOR DAY SALE',       start: addDays(nthWeekday(Y, 8, 1, 1), -3), end: nthWeekday(Y, 8, 1, 1) },
        { lead: 'BLACK FRIDAY SALE',    start: tg,                  end: addDays(tg, 3) },
        { lead: 'CYBER MONDAY SALE',    start: addDays(tg, 4),      end: addDays(tg, 4) },
        { lead: 'CHRISTMAS SALE',       start: new Date(Y, 11, 10), end: new Date(Y, 11, 25) },
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 11, 26), end: new Date(Y, 11, 31) }
      ];
    };
    var pac;
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { g[x.type] = x.value; });
      pac = new Date(parseInt(g.year, 10), parseInt(g.month, 10) - 1, parseInt(g.day, 10));
    } catch (e) { pac = new Date(); }
    var W = windowsFor(pac.getFullYear()), t = pac.getTime(), lead = null;
    for (var i = 0; i < W.length; i++) { if (t >= W[i].start.getTime() && t <= W[i].end.getTime()) { lead = W[i].lead; break; } }
    if (lead) barMsgEl.innerHTML = barMsgEl.innerHTML.replace(/^[^:]*:/, lead + ':');
  })();

  /* ---------- 2026 holiday offer: seasonal wording + the free-gift picker ----------
     Runs BEFORE the NORMAL capture below, so switching back from a flash deal restores this
     wording and not the everyday offer. The flash sale is still never combined with the gifts:
     applySale() hides every .js-camera element (the picker, the gift rows) and uses SALE_CART.
     Gifts Shopify reports as sold out are hidden by the stock check at the end of this block. */
  var renderGift = function () {};
  (function () {
    if (!holiday) return;
    var setHTML = function (id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; };
    var closestOf = function (id, sel) { var el = document.getElementById(id); return el && el.closest(sel); };
    document.body.classList.add('holiday');
    if (HOLIDAY_THEMES && !/[?&]theme=off/.test(location.search)) document.body.classList.add('themed', 'theme-' + (holiday.theme || holiday.key));
    // the season's name as a styled chip (.hol-<key> in style-d.css); PRE- takes the red <em> accent
    var chip = '<span class="hol hol-' + holiday.key + '">' + holiday.lead.replace(/^PRE-/, '<em>PRE-</em>') + '</span>';
    setHTML('dealBadge', holiday.badge);
    setHTML('dtBundle', '<b>🎁 + Free gift</b><span>$' + bundlePrice() + ' · + $20 gift card</span>');
    setHTML('picksTitle', holiday.pick);
    setHTML('spWin', '$20 OFF <i>+</i> FREE Gift');
    setHTML('jpGift', '<div class="jp-ic">🎁</div><b>FREE Gift</b><span>your pick, up to $200</span>');
    setHTML('popSub3', 'Enter your email to lock in $20 off + your free gift');
    setHTML('popDoneGift', 'Your free gift and $20 gift card are already in the deal.');
    setHTML('faqGift', 'Your free gift ships right alongside your scanner at no extra cost, and the $20 gift card is digital, so there is nothing to ship.');
    setHTML('cam3360Cta', 'Choose the 3360 &rarr;');

    // from Nov 6 CarMD Connect is no gift (carmdOn): its card leaves the picker, which closes up to two columns, and the
    // CarMD Connect section goes (body.no-carmd)
    if (!GIFTS.carmd) {
      document.body.classList.add('no-carmd');
      var cmdPick = document.getElementById('pickCarmd'), cmdCard = cmdPick && cmdPick.closest('.pick');
      if (cmdCard) { cmdCard.parentNode.classList.add('two'); cmdCard.parentNode.removeChild(cmdCard); }
    }
    var radios = [].slice.call(document.querySelectorAll('input[name="freeGift"]'));
    var cards = {}, imgFor = {};   // the picker photos double as the cart thumbnails (their src is Shopify-rewritten)
    radios.forEach(function (r) {
      cards[r.value] = r.closest('.pick');
      var im = r.parentNode.querySelector('label img'); if (im) imgFor[r.value] = im.getAttribute('src');
    });
    var ciImg = document.getElementById('ciGiftImg');
    var giftRow = closestOf('giftRowName', '.srow'), giftItem = closestOf('ciGiftName', '.citem');
    // the gift's half of the offer line on the first gallery photo
    var goName = document.getElementById('goGiftName'), goPic = document.getElementById('goGiftPic'), goImg = document.getElementById('goGiftImg'), goPlus = document.getElementById('goPlus');
    // the gift's picture there: while it is CarMD Connect, a click opens the CarMD window (a copy of the
    // CarMD Connect section, set up at the end of this file). Any other gift's picture is a plain picture,
    // and a click on it opens the photo viewer like the rest of the photo. When CarMD Connect sells out the
    // next gift takes its place, so the CarMD window can no longer be reached.
    if (goPic) goPic.addEventListener('click', function (e) {
      if (giftKey !== 'carmd') return;
      e.stopPropagation();                         // and not the photo viewer
      document.dispatchEvent(new CustomEvent('carmd:window'));
    });
    renderGift = function () {
      var g = giftKey ? GIFTS[giftKey] : null;   // null only when every gift is sold out
      var value = MSRP + (g ? g.value : 0) + GIFT_CARD_VALUE + F_BOOT + F_APP + F_SHIP;
      var save = value - bundlePrice(), pct = Math.round(save / value * 100);
      [giftRow, giftItem, goName, goPic, goPlus].forEach(function (el) { if (el) el.hidden = !g; });   // the picker itself stays, greyed out
      if (g) {
        setHTML('giftRowName', g.name);
        setHTML('giftRowVal', '$' + g.value);
        setHTML('ciGiftName', g.cartName);
        setHTML('ciGiftSub', 'A $' + g.value + ' value, included free');
        setHTML('ciGiftWas', '$' + g.value);
        if (ciImg && imgFor[giftKey]) { ciImg.setAttribute('src', imgFor[giftKey]); ciImg.setAttribute('alt', g.name); }
        if (goName && cards[giftKey]) goName.textContent = cards[giftKey].querySelector('.pick-n').textContent;
        if (goImg && imgFor[giftKey]) goImg.setAttribute('src', imgFor[giftKey]);
        if (goPic) {
          var isCarmd = giftKey === 'carmd';
          goPic.classList.toggle('is-carmd', isCarmd);
          goPic.tabIndex = isCarmd ? 0 : -1;
          goPic.setAttribute('aria-hidden', isCarmd ? 'false' : 'true');
          goPic.setAttribute('aria-label', isCarmd ? 'More about CarMD Connect' : '');
        }
      }
      radios.forEach(function (r) {
        r.checked = (r.value === giftKey);
        if (cards[r.value]) cards[r.value].classList.toggle('on', r.checked);
      });
      mailSync();                  // the email price's box shows with CarMD Connect only
      if (saleActive) return;      // the flash deal owns the banner, the numbers and the cart until they switch back
      var offTxt = ' $' + (MSRP - bundlePrice()) + ' OFF';
      setHTML('barMsg', chip + (g ? offTxt + ' <span class="and">+</span> A FREE GIFT <span class="and">+</span> $20 GIFT CARD'
                                  : offTxt + ' <span class="and">+</span> A $20 GIFT CARD'));
      // the scanner's price wherever it shows ($299 with the email price; the flash sale sets its own)
      var pr = '$' + bundlePrice();
      setHTML('dealPrice', pr); setHTML('dealScanPrice', '<s>$' + MSRP + '</s> ' + pr); setHTML('vsCost', pr);
      setHTML('cmpPrice', '<s>$' + MSRP + '</s> ' + pr); setHTML('cartScanPrice', pr);
      setHTML('dealPill', 'Save ' + pct + '%');
      setHTML('dealValue', '$' + value + ' total value');
      setHTML('dealSave', 'You save $' + save + ' &rarr;');
      setHTML('cartSaveText', '$' + save + ' &middot; ' + pct + '% OFF');
      setHTML('cartRetail', '$' + value);
      setHTML('cartDiscount', '&minus;$' + save);
      setCheckout(bundleCart());
    };
    var soldOut = {};
    // a sold-out gift stays in the picker, greyed out and marked, but can't be picked
    var markSoldOut = function (key, out) {
      soldOut[key] = out;
      var card = cards[key]; if (!card) return;
      card.classList.toggle('is-out', out);
      var r = card.querySelector('input'); if (r) r.disabled = out;
      var v = card.querySelector('.pick-v'); if (out && v) v.textContent = 'Sold out';
    };
    var choose = function (key) { if (!GIFTS[key] || soldOut[key]) return; giftKey = key; renderGift(); };
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) choose(r.value); }); });
    // "Choose the 3380" etc. inside the gift modals (they also close the modal and scroll to the offer)
    document.querySelectorAll('[data-pick]').forEach(function (el) {
      el.addEventListener('click', function () { choose(el.getAttribute('data-pick')); });
    });
    renderGift();

    /* stock check (checkStock, above): a sold-out gift stays on show but greyed out and unpickable; if it
       was the picked one, the next gift in line is picked. If all three are gone, the bundle carries on
       with just the gift card. */
    var keys = Object.keys(GIFTS);
    checkStock(keys, function (avail) {
      var inStock = keys.filter(function (k) { return avail[k] !== false; });
      keys.forEach(function (k) { markSoldOut(k, avail[k] === false); });
      // the CarMD Connect section above the offer only belongs there while CarMD can be picked
      document.body.classList.toggle('no-carmd', !GIFTS.carmd || avail.carmd === false);
      if (!inStock.length) {                     // all three sold out: the bundle keeps the gift card
        giftKey = null;
        setHTML('picksTitle', keys.length === 3 ? 'All three gifts are sold out' : 'The free gifts are sold out');
        setHTML('picksSub', 'Your $20 Innova gift card is still included.');
        setHTML('dtBundle', '<b>🎁 + Gift card</b><span>$' + bundlePrice() + ' · + $20 gift card</span>');
        setHTML('picksCardTitle', 'A free $20 Innova gift card');
        setHTML('spWin', '$20 OFF <i>+</i> $20 Gift Card');
        setHTML('jpGift', '<div class="jp-ic">🎁</div><b>$20 Gift Card</b><span>included free</span>');
        setHTML('popSub3', 'Enter your email to lock in $20 off + your $20 gift card');
        setHTML('popDoneGift', 'Your $20 gift card is already in the deal.');
        setHTML('faqGift', 'Your $20 gift card is digital, so there is nothing to ship.');
        renderGift();
        return;
      }
      if (inStock.length === 1) {                // one left: nothing to pick between
        setHTML('picksTitle', holiday.pick.replace(/: pick one$/, ''));
        setHTML('picksSub', 'It ships free with your 5610.');
      }
      // the next gift in the picker's order (Object.keys lists "3360" and "3380" before "carmd": number-like keys come
      // first), so on Black Friday a sold-out 3360 gives way to CarMD Connect
      if (avail[giftKey] === false) choose(['carmd', '3360', '3380'].filter(function (k) { return GIFTS[k] && avail[k] !== false; })[0]);
    });
  })();

  /* capture the normal (non-sale) copy so the toggle can switch back to it */
  var NORMAL = {};
  ['barMsg', 'dealBadge', 'dealPill', 'dealScanPrice', 'dealPrice', 'dealValue', 'dealSave', 'vsCost', 'cmpPrice',
   'cartCount', 'cartSaveText', 'cartScanPrice', 'cartRetail', 'cartDiscount'].forEach(function (id) {
    var el = document.getElementById(id); if (el) NORMAL[id] = el.innerHTML;
  });
  var applyNormal = function () {
    saleActive = false;
    document.body.classList.remove('sale-mode');
    Object.keys(NORMAL).forEach(function (id) { var el = document.getElementById(id); if (el) el.innerHTML = NORMAL[id]; });
    setCheckout(bundleCart());
    renderGift();                 // holiday: re-apply whichever gift they picked (no-op otherwise)
  };

  /* promo toggle: default = discounted (applySale); alt = full price + free camera (applyNormal) */
  var dealToggle = document.getElementById('dealToggle');
  var setToggleUI = function (mode) {
    if (!dealToggle) return;
    dealToggle.querySelectorAll('[data-offer]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-offer') === mode); });
  };
  var activatePromo = function (cfg) {
    promoActive = true; promoCfg = cfg;
    /* A flash sale leads with the $269 deal and no gift, so the CarMD Connect section above the offer
       stands down for this visit (body.flash-lead). Only while the visitor is still near the top, though:
       the sale sheet answers a moment after load, and pulling a section out from above someone who has
       already scrolled would jump the page under them. On that rare visit it stays, and its button
       switches the offer to the gift bundle (data-offer-go, below). */
    var scrolled = Math.max(window.pageYOffset || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
    if (scrolled < 400) document.body.classList.add('flash-lead');
    if (dealToggle) dealToggle.hidden = noCamera;   // with the camera sold out there is nothing to switch to
    applySale(cfg);               // default to the discount
    setToggleUI('sale');
  };
  if (dealToggle) dealToggle.querySelectorAll('[data-offer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-offer');
      if (mode === 'sale') applySale(promoCfg); else applyNormal();
      setToggleUI(mode);
    });
  });
  /* A button that asks for the gift bundle (the CarMD Connect section's) also has to leave the flash
     deal, on the rare visit where that section shows during a flash sale. Its data-pick, wired in the
     holiday block above, has already made CarMD the picked gift by the time this runs. */
  document.querySelectorAll('[data-offer-go="camera"]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (promoActive && saleActive && dealToggle && !dealToggle.hidden) { applyNormal(); setToggleUI('camera'); }
    });
  });

  /* ---------- everyday offer: go without the camera when the 3360 is sold out ----------
     Outside the holiday window the bundle promises a free 3360. If Shopify says it is sold out, drop it
     everywhere rather than promise something that can't ship: the .js-camera elements hide (as they do
     for a flash sale), the values are recalculated without it, and the cart link carries neither the
     camera nor its code. It comes back by itself once restocked. Preview: ?soldout=3360 (during the
     holidays add phase=off too). */
  if (!holiday) checkStock(['3360'], function (avail) {
    if (avail['3360'] !== false) return;
    noCamera = true;
    document.body.classList.add('no-camera');
    // the camera stays on show in the offer, marked sold out, so nobody wonders where the gift went
    var camRow = document.getElementById('giftRowName'); camRow = camRow && camRow.closest('.srow');
    var camSv = camRow && camRow.querySelector('.sv');
    if (camSv) { camSv.className = 'sv out'; camSv.textContent = 'Sold out'; }
    var camBlock = document.querySelector('.gift.js-soldshow');
    if (camBlock) {
      var camT = camBlock.querySelector('.t'), camS = camBlock.querySelector('.s');
      if (camT) camT.textContent = 'Free 3360 Thermal Camera: sold out';
      if (camS) camS.textContent = 'This gift is gone for now. Everything else in your bundle is still included.';
    }
    var setHTML = function (id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; };
    var value = MSRP + F_BOOT + F_APP + F_SHIP, save = value - BUNDLE_PRICE, pct = Math.round(save / value * 100);
    // rewrite the stored everyday copy, so nothing can put the camera wording back
    NORMAL.barMsg = (NORMAL.barMsg || 'SPECIAL OFFER').split(':')[0] + ': Get $' + (MSRP - BUNDLE_PRICE) + ' OFF';
    NORMAL.dealPill = 'Save ' + pct + '%';
    NORMAL.dealValue = '$' + value + ' total value';
    NORMAL.dealSave = 'You save $' + save + ' &rarr;';
    NORMAL.cartSaveText = '$' + save + ' &middot; ' + pct + '% OFF';
    NORMAL.cartRetail = '$' + value;
    NORMAL.cartDiscount = '&minus;$' + save;
    setHTML('spWin', '$20 OFF');
    setHTML('jpHead', '🎉 You won <b>$20 OFF</b>');
    ['jpPlus', 'jpGift'].forEach(function (id) { var el = document.getElementById(id); if (el) el.hidden = true; });
    setHTML('popSub3', 'Enter your email to lock in $20 off');
    setHTML('popDoneGift', '');
    setHTML('faqGift', '');
    if (dealToggle) dealToggle.hidden = true;      // during a flash sale there is nothing to switch to
    if (promoActive) { applySale(promoCfg); setToggleUI('sale'); }
    else applyNormal();
  });

  var pacificNow = function () {
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      return g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
    } catch (e) { return null; }
  };
  // normalize whatever Google Sheets exports into a zero-padded "YYYY-MM-DD HH:MM" so string compare is safe
  var toKey = function (s) {
    s = (s || '').trim(); if (!s) return '';
    var dm = s.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/) || s.match(/(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (!dm) return '';
    var y, mo, d;
    if (dm[1].length === 4) { y = dm[1]; mo = dm[2]; d = dm[3]; } else { mo = dm[1]; d = dm[2]; y = dm[3]; }
    var hh = 0, mm = 0, tm = s.match(/(\d{1,2}):(\d{2})\s*([ap]m)?/i);
    if (tm) {
      hh = parseInt(tm[1], 10); mm = parseInt(tm[2], 10);
      var ap = (tm[3] || '').toLowerCase();
      if (ap === 'pm' && hh < 12) hh += 12;
      if (ap === 'am' && hh === 12) hh = 0;
    }
    var p = function (n, w) { n = String(parseInt(n, 10) || 0); while (n.length < w) n = '0' + n; return n; };
    return p(y, 4) + '-' + p(mo, 2) + '-' + p(d, 2) + ' ' + p(hh, 2) + ':' + p(mm, 2);
  };

  var checkSale = function (rows) {
    var now = pacificNow(); if (!now) return;
    for (var i = 0; i < rows.length; i++) {
      var start = toKey(rows[i].start), end = toKey(rows[i].end);
      if (start && end && start <= now && now < end) {
        activatePromo({ price: parseInt(rows[i].price, 10) || 269, camera: /^\s*(yes|true|1)\s*$/i.test(rows[i].camera || '') });
        return;
      }
    }
  };
  var parseCSV = function (text) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (lines.length < 2) return [];
    var head = lines[0].split(',').map(function (h) { return h.trim().toLowerCase().replace(/^"|"$/g, ''); });
    var find = function (names) { for (var i = 0; i < head.length; i++) for (var j = 0; j < names.length; j++) if (head[i].indexOf(names[j]) === 0) return i; return -1; };
    var iS = find(['start']), iE = find(['end']), iP = find(['price']), iC = find(['3360', 'camera']);
    var rows = [];
    for (var k = 1; k < lines.length; k++) {
      var c = lines[k].split(',').map(function (v) { return v.trim().replace(/^"|"$/g, ''); });
      rows.push({ start: c[iS], end: c[iE], price: iP >= 0 ? c[iP] : '', camera: iC >= 0 ? c[iC] : '' });
    }
    return rows;
  };

  if (/[?&]sale=preview/.test(location.search)) {
    activatePromo({ price: 269, camera: false });             // test the promo layout without a live window
  } else if (/[?&]sale=off/.test(location.search)) {
    /* preview only: ignore the sale sheet, to see the page as it looks outside a flash sale */
  } else if (SALE_SHEET_URL) {
    fetch(SALE_SHEET_URL + (SALE_SHEET_URL.indexOf('?') >= 0 ? '&' : '?') + '_cb=' + Math.floor(Date.now() / 60000))
      .then(function (r) { return r.text(); })
      .then(function (t) { checkSale(parseCSV(t)); })
      .catch(function () { /* network/CORS failure -> stay in normal mode (fail safe) */ });
  }

  /* slide-in cart: offer-section CTAs open it; every other CTA scrolls to the offer section */
  var cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    /* 5-minute "cart reserved" countdown — starts on first open, persists across opens */
    var cartTimerEl = document.getElementById('cartTimer');
    var cartEnd = 0, cartInt = null, pad2 = function (n) { return String(n).padStart(2, '0'); };
    var renderCartTimer = function () {
      if (!cartTimerEl) return;
      var d = Math.max(0, cartEnd - Date.now());
      cartTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000));
      if (d <= 0 && cartInt) { clearInterval(cartInt); cartInt = null; }
    };
    var startCartTimer = function () {
      var now = Date.now();
      if (!cartEnd || cartEnd - now <= 0) cartEnd = now + 5 * 60 * 1000;   // (re)start a fresh 5:00 if none/expired
      renderCartTimer();
      if (!cartInt) cartInt = setInterval(renderCartTimer, 1000);
    };

    var openCart = function () {
      cartDrawer.classList.add('open');       // display:block
      void cartDrawer.offsetWidth;            // reflow so the transition runs from the off-screen state
      cartDrawer.classList.add('show');       // slide in + fade overlay
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      startCartTimer();
    };
    var closeCart = function () {
      cartDrawer.classList.remove('show');    // slide out
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      setTimeout(function () { if (!cartDrawer.classList.contains('show')) cartDrawer.classList.remove('open'); }, 440);
    };
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart();
    });

    var scrollToBuy = function () {
      var buy = document.getElementById('buy'), again = document.getElementById('buyBottom');
      // with the offer repeated near the end, a button goes to whichever of the two is nearer
      if (buy && again && again.firstChild && Math.abs(again.getBoundingClientRect().top) < Math.abs(buy.getBoundingClientRect().top)) buy = again;
      // scrollIntoView scrolls whatever the real container is (window.scrollTo no-ops on Shopify,
      // where the theme makes <body> the scroller). Bar offset handled via CSS scroll-margin-top.
      if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    /* Fire a CTA-click event into whatever analytics the store has (Meta Pixel, GA4, GTM dataLayer).
       Lets you gauge interest = how many people click a buy CTA. The button_text/location params let
       you isolate the actual "Claim Offer" buttons from the other CTAs in reports. No-op on the
       standalone page (none of these globals exist there). */
    var trackCTA = function (el) {
      var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var where = el.closest('#buy') ? 'offer'
                : el.closest('#buyBottom') ? 'offer-bottom'
                : el.closest('.bar') ? 'announcement'
                : el.closest('.hero') ? 'hero'
                : el.closest('.final') ? 'final'
                : el.closest('.pop') ? 'popup'
                : el.closest('.modal') ? 'modal'
                : el.closest('.cmd') ? 'carmd' : 'other';
      try { if (window.fbq) fbq('trackCustom', 'ClaimOfferClick', { button_text: label, location: where }); } catch (e) {}
      try { if (window.gtag) gtag('event', 'claim_offer_click', { button_text: label, location: where }); } catch (e) {}
      try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'claim_offer_click', button_text: label, location: where }); } catch (e) {}
    };
    /* The offer opens this page (#buy.buy-first) and is repeated near the end. While either offer's buy
       button is on screen, a scroll to the offer would do nothing, so a button outside it opens the cart. */
    var firstBuy = function () { return [].some.call(document.querySelectorAll('.buy-first .claim-first'), onScreen); };
    var onScreen = function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    };
    document.querySelectorAll('.js-checkout').forEach(function (el) {
      var inOffer = !!el.closest('#buy');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        trackCTA(el);                // record the click for interest tracking
        // Claim Offer + "You save $529" open the cart, and so does the last section's button (data-cart),
        // which comes after the repeated offer with only the FAQ between them
        if (inOffer || el.hasAttribute('data-cart') || firstBuy()) openCart();
        else scrollToBuy();          // all other CTAs bring the user to the offer section
      });
    });
    // the repeated offer near the end (#buyBottom) is a copy made by the script at the end of this file,
    // after these buttons were wired, so its buy buttons are handled here as they are clicked
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('#buyBottom .js-checkout');
      if (!el) return;
      e.preventDefault();
      trackCTA(el);
      openCart();
    });
  }

  /* ---------- promo popup (car matcher + email capture) ---------- */
  /* ====== KLAVIYO SETUP: paste your two values below ======
     KLAVIYO_PUBLIC_KEY = your public API key (a.k.a. Company/Site ID, 6 chars)
     KLAVIYO_LIST_ID    = the List ID you want subscribers added to
     Leave them blank to run in demo mode (no network call).            */
  var KLAVIYO_PUBLIC_KEY = 'T9Ldwz';
  var KLAVIYO_LIST_ID = 'UgvmRt';
  var POPUP_DELAY_MS = 5000;   // show 5s after landing
  var PROMO_CODE = 'CRX2000';

  var POPUP_ENABLED = true;   // promo popup enabled. Set to false to temporarily turn it off.
  var pop = POPUP_ENABLED && document.getElementById('promoPop');
  if (pop) {
    var SEEN_KEY = 'innova_promo_seen';
    var steps = {};
    pop.querySelectorAll('.pop-step').forEach(function (s) { steps[s.getAttribute('data-step')] = s; });
    var showStep = function (n) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== String(n)); });
    };
    var initScratch = null;   // assigned below; called on open so the canvas has real dimensions
    var openPop = function () {
      if (pop.classList.contains('open')) return;
      pop.classList.toggle('pop--promo', promoActive);   // flash-sale variant during a promo
      pop.classList.add('open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      if (initScratch) initScratch();
    };
    var popTab = document.getElementById('popTab');
    var showTab = function () { if (popTab) { popTab.hidden = false; popTab.classList.add('show'); } };
    var hideTab = function () { if (popTab) { popTab.classList.remove('show'); popTab.hidden = true; } };
    var closePop = function () {
      pop.classList.remove('open');
      pop.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      if (!emailCaptured) showTab();      // minimize to a re-openable corner tab (unless they signed up)
    };
    if (popTab) popTab.addEventListener('click', function () { hideTab(); openPop(); });
    pop.querySelectorAll('[data-pop-close]').forEach(function (el) { el.addEventListener('click', closePop); });
    pop.querySelectorAll('[data-pop-goto]').forEach(function (el) {
      el.addEventListener('click', function () { showStep(promoActive ? '5' : el.getAttribute('data-pop-goto')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) closePop(); });

    /* jackpot claim countdown (starts when the jackpot step appears) */
    var jpTimerEl = document.getElementById('jpTimer');
    var jpEnd = 0, jpInt = null;
    var startJpTimer = function () {
      if (!jpTimerEl) return;
      if (!jpEnd) jpEnd = Date.now() + 10 * 60 * 1000;
      var r = function () { var d = Math.max(0, jpEnd - Date.now()); jpTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000)); if (d <= 0 && jpInt) { clearInterval(jpInt); jpInt = null; } };
      r(); if (!jpInt) jpInt = setInterval(r, 1000);
    };

    /* scratch-off: swipe/drag to reveal the discount, then advance to email */
    var scratch = document.getElementById('scratch');
    var canvas = document.getElementById('scratchCanvas');
    if (scratch && canvas && canvas.getContext) {
      var sctx = canvas.getContext('2d');
      var sized = false, scratching = false, revealed = false, lastPt = null;

      initScratch = function () {
        if (sized) return;
        var r = scratch.getBoundingClientRect();
        if (!r.width) return;                       // still hidden; will retry on next open call
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(r.width * dpr);
        canvas.height = Math.round(r.height * dpr);
        sctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = sctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#cbd0d8'); g.addColorStop(.5, '#aab0ba'); g.addColorStop(1, '#cbd0d8');
        sctx.fillStyle = g; sctx.fillRect(0, 0, r.width, r.height);
        sized = true;
      };

      var relPos = function (e) {
        var r = canvas.getBoundingClientRect();
        var t = e.touches && e.touches[0];
        return { x: (t ? t.clientX : e.clientX) - r.left, y: (t ? t.clientY : e.clientY) - r.top };
      };
      var eraseAt = function (x, y) {
        sctx.globalCompositeOperation = 'destination-out';
        sctx.beginPath(); sctx.arc(x, y, 22, 0, Math.PI * 2); sctx.fill();
        if (lastPt) { sctx.lineWidth = 44; sctx.lineCap = 'round'; sctx.beginPath();
          sctx.moveTo(lastPt.x, lastPt.y); sctx.lineTo(x, y); sctx.stroke(); }
        lastPt = { x: x, y: y };
      };
      var pctCleared = function () {
        try {
          var d = sctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0, total = 0;
          for (var i = 3; i < d.length; i += 4 * 24) { total++; if (d[i] === 0) clear++; }
          return total ? clear / total : 0;
        } catch (e) { return 0; }
      };
      var reveal = function () {
        if (revealed) return; revealed = true;
        sctx.clearRect(0, 0, canvas.width, canvas.height);
        scratch.classList.add('revealed');
        setTimeout(function () {
          if (promoActive) { showStep('5'); }              // -> flash-sale shop step (no email during a sale)
          else { showStep(2); startJpTimer(); }            // -> jackpot celebration
        }, 950);
      };
      var scratchMove = function (e) {
        if (!scratching || revealed) return;
        if (e.cancelable) e.preventDefault();
        var p = relPos(e); eraseAt(p.x, p.y);
        if (pctCleared() > 0.5) reveal();
      };
      var scratchStart = function (e) {
        if (!sized) initScratch();
        scratching = true; lastPt = null; scratch.classList.add('scratching');
        scratchMove(e);
      };
      var scratchEnd = function () { scratching = false; lastPt = null; };

      canvas.addEventListener('mousedown', scratchStart);
      window.addEventListener('mousemove', scratchMove);
      window.addEventListener('mouseup', scratchEnd);
      canvas.addEventListener('touchstart', scratchStart, { passive: false });
      canvas.addEventListener('touchmove', scratchMove, { passive: false });
      window.addEventListener('touchend', scratchEnd);
    }

    /* email submit -> Klaviyo */
    var form = document.getElementById('popForm');
    var emailIn = document.getElementById('popEmail');
    var errEl = document.getElementById('popErr');
    var codeEl = document.getElementById('popCode');
    if (codeEl) codeEl.textContent = PROMO_CODE;
    var validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };

    var subscribe = function (email, props) {
      if (!KLAVIYO_PUBLIC_KEY || !KLAVIYO_LIST_ID) return Promise.resolve('demo');
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_KEY), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: '5610 Landing Popup',
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        })
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
    };

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailIn.value || '').trim();
        if (!validEmail(email)) { if (errEl) errEl.hidden = false; emailIn.focus(); return; }
        if (errEl) errEl.hidden = true;
        var btn = form.querySelector('.pop-submit');
        btn.disabled = true; var label = btn.textContent; btn.textContent = 'Signing you up…';
        subscribe(email, {}).then(function () {
          try { localStorage.setItem(SEEN_KEY, '1'); localStorage.setItem('innova_email_captured', '1'); } catch (er) {}
          emailCaptured = true; hideTab();   // they signed up: no minimize tab
          setCheckout(bundleCart());         // add the CRX2000 discount now that we have the email
          showStep(4);
        }).catch(function () {
          btn.disabled = false; btn.textContent = label;
          if (errEl) { errEl.hidden = false; errEl.textContent = 'Something went wrong — please try again.'; }
        });
      });
    }

    /* fire 5s after landing; if already seen but not signed up, keep the re-open tab available */
    var seen = false; try { seen = !!localStorage.getItem(SEEN_KEY); } catch (e) {}
    /* not before 12:00 AM Pacific on Nov 12, 2026 (the user, Oct 27 2026: "until nov11, hide the $20 popup, show it only on
       nov 12 and later"; the $299 email price runs until then): no popup and no prize tab. ?popup=on shows it anyway. */
    var POPUP_FROM = '2026-11-12 00:00';
    var popupLater = (function () {
      if (/[?&]popup=on\b/.test(location.search)) return false;
      try {
        var g = {};
        new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
          day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
          .forEach(function (x) { g[x.type] = x.value; });
        return (g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute) < POPUP_FROM;
      } catch (e) { return false; }
    })();
    if (popupLater || dropOn) { /* nothing until Nov 12, nor in the $299 week (PRICE_DROP) */ }
    else if (!seen) setTimeout(openPop, POPUP_DELAY_MS);      // shows jackpot (normal) or flash-sale (promo) variant
    else if (!emailCaptured) showTab();
  }

  /* ---------- the email price's box (see MAIL_DEAL) ----------
     Above Claim Offer, and copied into the repeated offer near the end, so it is handled from the document (a submit
     from either). It shows while the email price runs and no flash sale is on screen (body.sale-mode hides it). An
     email unlocks both, the page and every gift link; Klaviyo hears which one it came from (custom_source). */
  (function () {
    var box = document.getElementById('mailDeal');
    if (!box || !mailOpen) return;
    // the phone photo makes room for the box if it shows on landing, and keeps that size after a gift is picked, so the
    // page doesn't jump when the box comes and goes with CarMD Connect
    if (mailGift()) document.body.classList.add('mail-room');
    mailSync();                                  // shows the locked price while CarMD Connect is the gift
    var showDone = function () {
      [].forEach.call(document.querySelectorAll('.dp-mail'), function (b) {
        var f = b.querySelector('.md-form'), d = b.querySelector('.md-done'); if (f) f.hidden = true; if (d) d.hidden = false;
      });
      mailSync();
    };
    box.hidden = false;
    if (mailEmail) showDone();
    // "Email to unlock $299" is cut off in a field this narrow; the lock beside the price says it already
    if (window.matchMedia && matchMedia('(max-width: 379px)').matches) box.querySelector('input').setAttribute('placeholder', 'Your email');
    var valid = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
    var subscribe = function (email, place) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(MAIL_DEAL.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { custom_source: '5610 Partnerships Page $299 Email Price (' + place + ')',
            profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: MAIL_DEAL.list } } } } })
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
    };
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('.dp-mail .md-form');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input[type="email"]'), err = form.querySelector('.md-err');
      var place = form.closest('.dp-mail').getAttribute('data-place') || 'offer';
      var email = (input.value || '').trim();
      if (!valid(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var btn = form.querySelector('.md-go'), label = btn.textContent;
      btn.disabled = true; btn.textContent = 'One moment…';
      (mailEmail === 'preview' ? Promise.resolve() : subscribe(email, place)).then(function () {
        mailEmail = email;
        try { localStorage.setItem(MAIL_DEAL.store, email); } catch (er) {}
        showDone();
        if (holiday) renderGift(); else setCheckout(bundleCart());   // $299 everywhere, the code in every gift link
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
      });
    });
  })();

  /* ---------- anchor scrolling ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      // scrollIntoView targets the real scroll container (window.scrollTo no-ops on Shopify, where
      // the theme makes <body> the scroller). Bar offset handled via CSS scroll-margin-top.
      if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- come back to this tab: alert the title + favicon when the user leaves ---------- */
  (function () {
    var origTitle = document.title;
    var favEl = document.querySelector('link[rel~="icon"]');
    if (!favEl) { favEl = document.createElement('link'); favEl.rel = 'icon'; document.head.appendChild(favEl); }
    // On Shopify our section (and its <link rel="icon">) renders inside <body>, where browsers
    // ignore it — so the tab shows no favicon and the dot swap has nothing to affect. Move it into
    // <head> so the icon actually displays. No-op on the standalone page (link is already in <head>).
    else if (!favEl.closest('head')) { document.head.appendChild(favEl); }
    var origHref = favEl.getAttribute('href');
    var badgedHref = null;

    // build a copy of the favicon with a red notification dot
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 32; c.height = 32;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, 32, 32);
        ctx.beginPath(); ctx.arc(23, 9, 8, 0, 2 * Math.PI);
        ctx.fillStyle = '#da291c'; ctx.fill();
        ctx.lineWidth = 2.5; ctx.strokeStyle = '#fff'; ctx.stroke();
        badgedHref = c.toDataURL('image/png');
      } catch (e) { /* canvas blocked, title alert still works */ }
    };
    if (origHref) img.src = origHref;

    var ALERTS = ['🔴 Your deal is waiting', '👋 Come back for $200 OFF'];
    var flip = null, i = 0;
    var setFav = function (h) { if (h) favEl.setAttribute('href', h); };

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        setFav(badgedHref);
        i = 0; document.title = ALERTS[0];
        if (!flip) flip = setInterval(function () {
          i = (i + 1) % (ALERTS.length + 1);
          document.title = i === 0 ? origTitle : ALERTS[i - 1];   // blink between the real title and the alerts
        }, 1400);
      } else {
        if (flip) { clearInterval(flip); flip = null; }
        document.title = origTitle;
        setFav(origHref);
      }
    });
  })();
})();


/* ==========================================================================
   3D WIREFRAME SPORTS CAR
   Hand-rolled: model-space vertices, Y-rotation, X-tilt, perspective divide,
   painter-ordered edges. No libraries. Two instances share one model:
     .wire  #truckWire      "sweep"   - a scan plane travels the length
     .wire  #truckWireFeat  "systems" - each subsystem lights in turn
   Both pause off-screen and go static under prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';
  var a = document.getElementById('truckWire');
  var b = document.getElementById('truckWireFeat');
  if (!a && !b) return;

  /* ---------- model (built once, shared) ----------
     A low sports coupe: x runs from the nose (-100) to the tail (+100), y is up, the floor is 0.
     Every profile point carries its own half-width, so the cabin sits narrower than the fenders
     (tumblehome) and the nose tapers in plan. The lower edge arches over each wheel instead of
     running flat, which is most of what separates a car silhouette from a box. */
  var V = [], E = [];
  function vtx(x, y, z) { V.push([x, y, z]); return V.length - 1; }
  function edge(p, q, w, kind) { E.push([p, q, w === undefined ? 1 : w, kind || '']); }

  var BODY = 38, CABIN = 26, SILL = 6;
  var WHEEL_R = 15, WHEEL_Y = 15, ARCH_R = 18, FRONT_X = -62, REAR_X = 60;
  function arch(wx) {                                    // rear edge, up over the wheel, front edge
    var pts = [];
    for (var d = -30; d <= 210; d += 30) {
      var r = d * Math.PI / 180;
      pts.push([wx + Math.cos(r) * ARCH_R, WHEEL_Y + Math.sin(r) * ARCH_R, BODY, 0]);
    }
    return pts;
  }
  /* [x, y, half-width, cross-member?] traced nose -> roof -> tail, then back along the underside */
  var PROFILE = [
    [-100, 12, 30, 1], [-97, 19, 33, 1], [-80, 27, 36, 0], [-62, 37, BODY, 0],   // nose, hood, front fender
    [ -38, 35, 33, 1],                                                           // cowl
    [  -8, 50, CABIN, 1], [14, 51, CABIN, 1],                                    // raked windscreen, short roof
    [  48, 39, 33, 1], [60, 40, BODY, 0], [86, 39, 36, 0],                       // fastback, rear haunch, deck
    [  93, 42, 35, 1], [100, 36, 33, 0], [100, 22, 33, 1],                       // ducktail spoiler, tail
    [  96,  8, 34, 0], [88, SILL, 36, 0]
  ].concat(arch(REAR_X), arch(FRONT_X), [[-92, SILL, 34, 0], [-98, 8, 31, 0]]);

  var Lp = [], Rp = [];
  PROFILE.forEach(function (p) { Lp.push(vtx(p[0], p[1], -p[2])); Rp.push(vtx(p[0], p[1], p[2])); });
  for (var i = 0; i < PROFILE.length; i++) {
    var nx = (i + 1) % PROFILE.length;
    edge(Lp[i], Lp[nx]); edge(Rp[i], Rp[nx]);
    if (PROFILE[i][3]) edge(Lp[i], Rp[i], .5);
  }
  edge(Lp[4], Lp[7], .45); edge(Rp[4], Rp[7], .45);      // window sill, cowl to fastback

  [-1, 1].forEach(function (sd) {
    function side(x, y, hw) { return vtx(x, y, sd * hw); }
    edge(side(-98, 15, 29), side(-84, 21, 35), .7);         // headlight
  });

  function ring(cx, cy, r, z, seg, w) {
    var first = -1, prev = -1;
    for (var k = 0; k < seg; k++) {
      var ang = k / seg * Math.PI * 2;
      var id = vtx(cx + Math.cos(ang) * r, cy + Math.sin(ang) * r, z);
      if (k === 0) first = id; else edge(prev, id, w, 'wheel');
      prev = id;
    }
    edge(prev, first, w, 'wheel');
  }
  [-1, 1].forEach(function (sd) {
    [FRONT_X, REAR_X].forEach(function (wx) {
      var z = sd * (BODY + 2);
      ring(wx, WHEEL_Y, WHEEL_R, z, 18, 1);                 // tyre
      ring(wx, WHEEL_Y, 10.5, z, 14, .55);                  // rim
      for (var sp = 0; sp < 5; sp++) {                       // five spokes
        var a5 = sp / 5 * Math.PI * 2 - Math.PI / 2;
        edge(vtx(wx + Math.cos(a5) * 3, WHEEL_Y + Math.sin(a5) * 3, z),
             vtx(wx + Math.cos(a5) * 10.5, WHEEL_Y + Math.sin(a5) * 10.5, z), 0.35, 'wheel');
      }
    });
  });

  /* tag every edge with the vehicle system it belongs to */
  E.forEach(function (e) {
    if (e[3] === 'wheel') { e[4] = 'brakes'; return; }
    var p = V[e[0]], q = V[e[1]];
    var my = (p[1] + q[1]) / 2, mx = (p[0] + q[0]) / 2;
    e[4] = (my > 34 && mx > -40 && mx < 52) ? 'airbags' : (mx < -30 ? 'engine' : 'transmission');
  });

  var GRID = [];
  for (var gx = -150; gx <= 150; gx += 30) GRID.push([[gx, 0, -95], [gx, 0, 95]]);
  for (var gz = -95; gz <= 95; gz += 30) GRID.push([[-150, 0, gz], [150, 0, gz]]);

  var SYSTEMS = [
    { k: 'engine',       label: 'Engine & emissions' },
    { k: 'brakes',       label: 'ABS brakes' },
    { k: 'airbags',      label: 'SRS airbags' },
    { k: 'transmission', label: 'Transmission' }
  ];

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Line colours come from CSS, so a holiday season can restyle the car: body.theme-<key> in
     style-d.css sets --wire* as "r,g,b". Outside a season nothing sets them and these fallbacks,
     the everyday red, apply. A lit edge runs from the hot colour up toward white. */
  function rgbVar(name, fallback) {
    var m = null;
    try { m = getComputedStyle(document.body).getPropertyValue(name).match(/^\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*$/); } catch (e) {}
    return m ? [+m[1], +m[2], +m[3]] : fallback;
  }
  var C_LINE = rgbVar('--wire', [232, 72, 48]).join(','), C_HOT = rgbVar('--wire-hot', [255, 120, 90]);
  var C_GLOW = rgbVar('--wire-glow', [255, 90, 60]).join(','), C_GRID = rgbVar('--wire-grid', [150, 170, 200]).join(',');
  function lit(i, near) { return Math.round(C_HOT[i] + (Math.max(C_HOT[i], 230) - C_HOT[i]) * near); }

  /* ---------- one animated instance ---------- */
  function mount(cv, opts) {
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1, TILT = 0.18;
    var labelEl = opts.labelEl || null, shownSys = -1;

    function resize() {
      var r = cv.getBoundingClientRect();
      if (!r.width) return false;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return true;
    }

    function project(p, cosY, sinY, scale, cx, cy) {
      var x = p[0] * cosY - p[2] * sinY;
      var z = p[0] * sinY + p[2] * cosY;
      var y = p[1] - 26;
      var ct = Math.cos(TILT), st = Math.sin(TILT);
      var y2 = y * ct - z * st;
      var z2 = y * st + z * ct;
      var d = 460 / (460 + z2);
      return [cx + x * d * scale, cy - y2 * d * scale, z2];
    }

    function frame(t) {
      if (!W && !resize()) return;
      var rot = reduce ? 0.45 : 0.42 + Math.sin(t / 6500) * 0.45;
      var cosY = Math.cos(rot), sinY = Math.sin(rot);
      var scale = Math.min(W / 240, H / 96);
      var cx = W / 2, cy = H / 2 + H * 0.07;

      /* which system is lit, and how strongly */
      var sysIdx = -1, sysMix = 0;
      if (opts.mode === 'systems') {
        var per = 2700;
        sysIdx = reduce ? 0 : Math.floor(t / per) % SYSTEMS.length;
        var phase = reduce ? 0.5 : (t % per) / per;
        sysMix = Math.min(1, Math.min(phase, 1 - phase) * 6);   // ease in and out
        if (labelEl && sysIdx !== shownSys) { labelEl.textContent = SYSTEMS[sysIdx].label; shownSys = sysIdx; }
      }
      var sweep = (opts.mode === 'systems' || reduce) ? 1e9 : (((t / 2600) % 1) * 300 - 150);

      ctx.clearRect(0, 0, W, H);

      ctx.lineWidth = 1;
      GRID.forEach(function (g) {
        var p = project(g[0], cosY, sinY, scale, cx, cy);
        var q = project(g[1], cosY, sinY, scale, cx, cy);
        var al = Math.max(0, 0.13 - ((p[2] + q[2]) / 2) / 2600);
        if (al <= 0.005) return;
        ctx.strokeStyle = 'rgba(' + C_GRID + ',' + al.toFixed(3) + ')';
        ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(q[0], q[1]); ctx.stroke();
      });

      var pts = V.map(function (p) { return project(p, cosY, sinY, scale, cx, cy); });
      var order = E.map(function (e, idx) { return [idx, (pts[e[0]][2] + pts[e[1]][2]) / 2]; })
                   .sort(function (m, n) { return n[1] - m[1]; });

      order.forEach(function (o) {
        var e = E[o[0]], p = pts[e[0]], q = pts[e[1]], depth = o[1];
        var fade = Math.max(0.18, Math.min(1, 1 - (depth + 60) / 230));
        var near;
        if (opts.mode === 'systems') {
          near = (e[4] === SYSTEMS[sysIdx].k) ? sysMix : 0;
        } else {
          var mx = (V[e[0]][0] + V[e[1]][0]) / 2;
          near = Math.max(0, 1 - Math.abs(mx - sweep) / 34);
        }

        ctx.lineWidth = (e[2] * 1.45 + near * 1.0);
        if (near > 0.02) {
          ctx.shadowBlur = 12 * near;
          ctx.shadowColor = 'rgba(' + C_GLOW + ',' + (0.85 * near).toFixed(3) + ')';
          ctx.strokeStyle = 'rgba(' + lit(0, near) + ',' + lit(1, near) + ',' +
                            lit(2, near) + ',' + (fade * (0.55 + 0.45 * near)).toFixed(3) + ')';
        } else {
          ctx.shadowBlur = 0;
          var dim = opts.mode === 'systems' ? 0.42 : 0.82;   // unlit systems recede
          ctx.strokeStyle = 'rgba(' + C_LINE + ',' + (fade * dim).toFixed(3) + ')';
        }
        ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(q[0], q[1]); ctx.stroke();
      });
      ctx.shadowBlur = 0;
    }

    var running = false, raf = 0;
    function tick(t) { frame(t); raf = requestAnimationFrame(tick); }
    function start() {
      if (running) return;
      running = true;
      // paint once up front: rAF is throttled in background tabs, and without this the
      // canvas can sit blank until the tab is focused
      try { frame(performance.now()); } catch (err) {}
      raf = requestAnimationFrame(tick);
    }
    function stop() { if (running) { running = false; cancelAnimationFrame(raf); } }
    window.addEventListener('resize', function () { W = 0; });

    // Always paint one frame at mount. IntersectionObserver callbacks and rAF are both
    // throttled while the document is hidden, so without this the canvas can stay blank
    // for a visitor who opens the page in a background tab.
    resize(); frame(0);
    if (reduce) return;
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { x.isIntersecting ? start() : stop(); });
      }, { threshold: 0.01 }).observe(cv);
    } else { start(); }
  }

  mount(a, { mode: 'sweep' });
  mount(b, { mode: 'systems', labelEl: document.getElementById('featSysLabel') });
})();

/* ==========================================================================
   SCROLL HINT
   The comparison tables are wider than a phone. Flag that on the section when
   a pane actually overflows, which reveals the "swipe" note sitting above the
   table. Measured rather than keyed to a breakpoint, so it never shows on a
   viewport where the table already fits.
   ========================================================================== */
(function () {
  'use strict';
  var panes = [].slice.call(document.querySelectorAll('.cmp-wrap, .vswrap'));
  if (!panes.length) return;
  panes.forEach(function (pane) {
    var sec = pane.closest('section');
    if (!sec) return;
    var sync = function () {
      sec.classList.toggle('is-scrollable', pane.scrollWidth - pane.clientWidth > 4);
    };
    window.addEventListener('resize', sync);
    // watch the TABLE too: the pane is a fixed-width scroll container, so its own
    // box never changes when the content reflows as the web font loads
    if (window.ResizeObserver) {
      try {
        var ro = new ResizeObserver(sync);
        ro.observe(pane);
        if (pane.firstElementChild) ro.observe(pane.firstElementChild);
      } catch (e) {}
    }
    window.addEventListener('load', sync);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(sync).catch(function () {}); }
    sync();
  });
})();

/* ==========================================================================
   CARMD CONNECT SECTION  (above the offer; holiday gift window only)
   The feature list and the photo are one control: the lit feature names the callout on the photo.
   It moves on by itself every few seconds until the visitor picks a feature, waits while the section
   is off screen or the list is under the pointer, and stays put under prefers-reduced-motion.
   The photo leans toward a mouse pointer (never on touch).
   Whether the section shows at all is decided in the holiday block and activatePromo, above.
   ========================================================================== */
(function () {
  'use strict';
  // The animation is set up on a root element, so the same code drives the section on the page and its
  // copy in the CarMD window that the CarMD picture on the offer photo opens.
  function cmdRun(sec) {
    var feats = [].slice.call(sec.querySelectorAll('.cmd-f'));
    var list = sec.querySelector('.cmd-list'), stage = sec.querySelector('.cmd-stage');
    var call = sec.querySelector('.cmd-call'), callK = sec.querySelector('.cmd-call-k'), callT = sec.querySelector('.cmd-call-t');
    var link = sec.querySelector('.cmd-link');
    if (!feats.length) return;

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var STEP = 5200;                 // keep in step with cmdProg in style-switch.css
    var cur = 0, auto = !reduce, onScreen = false, hovering = false, timer = 0;

    function plan() {
      clearTimeout(timer);
      var run = auto && onScreen && !hovering && !document.hidden;
      sec.classList.toggle('is-auto', run);
      if (run) timer = setTimeout(function () { show(cur + 1, false); }, STEP);
    }
    function show(i, byHand) {
      cur = (i + feats.length) % feats.length;
      feats.forEach(function (b, k) {
        b.classList.toggle('on', k === cur);
        b.setAttribute('aria-pressed', k === cur ? 'true' : 'false');
      });
      if (call && callK && callT) {
        call.classList.remove('swap');
        void call.offsetWidth;                                   // restart the swap-in animation
        callK.textContent = feats[cur].getAttribute('data-k');
        callT.textContent = feats[cur].getAttribute('data-t');
        call.classList.add('swap');
      }
      if (byHand) auto = false;                                  // a deliberate pick ends the slideshow
      plan();
    }
    feats.forEach(function (b, k) { b.addEventListener('click', function () { show(k, true); }); });
    if (list) {
      list.addEventListener('mouseenter', function () { hovering = true; plan(); });
      list.addEventListener('mouseleave', function () { hovering = false; plan(); });
    }
    document.addEventListener('visibilitychange', plan);

    // run the live parts only while the section is on screen
    function setOnScreen(v) {
      onScreen = v;
      sec.classList.toggle('is-idle', !v);
      try { if (link && link.pauseAnimations) { if (v && !reduce) link.unpauseAnimations(); else link.pauseAnimations(); } } catch (e) {}
      plan();
    }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { setOnScreen(x.isIntersecting); });
      }, { threshold: 0.2 }).observe(sec);
    } else { setOnScreen(true); }

    // the photo leans toward the pointer; the glare follows it
    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    var tilt = stage && stage.querySelector('.cmd-tilt');
    if (tilt && fine && !reduce) {
      var raf = 0, px = 0, py = 0;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        if (!r.width) return;
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          tilt.style.setProperty('--ry', (px * 9).toFixed(2) + 'deg');
          tilt.style.setProperty('--rx', (-py * 9).toFixed(2) + 'deg');
          tilt.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
          tilt.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      });
      stage.addEventListener('pointerleave', function () {
        tilt.style.setProperty('--ry', '0deg');
        tilt.style.setProperty('--rx', '0deg');
      });
    }
  }
  var carmdSec = document.getElementById('carmd');
  if (carmdSec) cmdRun(carmdSec);

  /* ---------- the CarMD window ----------
     The CarMD picture on the offer photo opens it (the user's request, Oct 14, 2026: "the same content
     shown at the bottom of the page, with the same animation"). The first time, it copies the section's
     grid in and starts the same animation on the copy. The copy drops the section's ids. Its button
     closes the window and brings the buy button into view rather than going on to the cart, since
     CarMD Connect is already the gift when the window can be opened. */
  (function () {
    var modal = document.getElementById('carmdModal');
    if (!modal || !carmdSec) return;
    var sheet = modal.querySelector('.cmd-sheet'), built = false, back = null;
    var close = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open') && !document.querySelector('.lbx.open')) document.body.classList.remove('modal-lock');
      if (back && back.focus) back.focus();
    };
    var open = function () {
      if (!built) {
        var copy = carmdSec.querySelector('.cmd-grid').cloneNode(true);
        [].forEach.call(copy.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
        var cta = copy.querySelector('.cmd-cta');
        if (cta) {
          cta.classList.remove('js-checkout');
          cta.addEventListener('click', function (e) {
            e.preventDefault();
            close();
            var buy = document.querySelector('.claim-first');
            if (buy && buy.scrollIntoView) buy.scrollIntoView({ block: 'center', behavior: 'smooth' });
          });
        }
        sheet.appendChild(copy);
        cmdRun(sheet);
        built = true;
      }
      back = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      var x = modal.querySelector('.cmd-x'); if (x) x.focus();
    };
    document.addEventListener('carmd:window', open);
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  })();

  /* ---------- "The technical side", a row of function cards scrolled sideways ----------
     The browser's own scrolling does the work (touch, trackpad, keyboard). This adds the arrows, the
     position bar and the count, and lets a mouse drag the row. */
  (function () {
    var rail = document.getElementById('techRail');
    if (!rail) return;
    var cards = rail.querySelectorAll('.tc');
    var feats = rail.querySelectorAll('.tc:not(.tc-more)').length;      // the last card is the link to the full list
    var prev = document.getElementById('techPrev'), next = document.getElementById('techNext');
    var bar = document.getElementById('techBar'), now = document.getElementById('techNow'), all = document.getElementById('techAll');
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var step = function () { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth; };
    if (all) all.textContent = two(feats);
    var raf = 0;
    var update = function () {
      raf = 0;
      var x = rail.scrollLeft, max = rail.scrollWidth - rail.clientWidth, s = step();
      if (bar) {
        bar.style.setProperty('--tw', (rail.clientWidth / rail.scrollWidth).toFixed(4));
        bar.style.setProperty('--tp', (x / rail.scrollWidth).toFixed(4));
      }
      if (prev) prev.disabled = x < 4;
      if (next) next.disabled = x > max - 4;
      rail.classList.toggle('at-end', x > max - 4);
      if (now) {      // the cards in view, as "01-04" (or just "01" when a phone shows one at a time)
        var first = Math.min(feats, Math.round(x / s) + 1);
        var last = Math.min(feats, Math.max(first, Math.floor((x + rail.clientWidth - 24) / s)));
        now.textContent = last > first ? two(first) + '-' + two(last) : two(first);
      }
    };
    var queue = function () { if (!raf) raf = requestAnimationFrame(update); };
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    var go = function (dir) {      // a screenful of cards at a time
      var s = step(), n = Math.max(1, Math.floor(rail.clientWidth / s));
      rail.scrollBy({ left: dir * n * s, behavior: still ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    // a mouse can drag the row; touch and trackpads already scroll it
    var down = false, dragged = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragged = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < 5) return;
      dragged = true;
      rail.classList.add('is-drag');
      rail.scrollLeft = startLeft - dx;
    });
    var release = function () { if (down) { down = false; rail.classList.remove('is-drag'); } };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    // letting go after a drag must not count as a click on the button in the last card
    rail.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    update();
  })();

  /* ---------- the "Your prize is waiting" tab stays out of the offer ----------
     The offer opens this page, so the tab only shows once the visitor is below it, and hides again on the
     way back up (the user's request, Oct 14, 2026). The same goes for the offer repeated near the end.
     The popup itself is unchanged. */
  (function () {
    var offers = [document.getElementById('buy'), document.getElementById('buyBottom')].filter(Boolean);
    if (!offers.length || !('IntersectionObserver' in window)) return;
    var seen = {};
    document.body.classList.add('in-offer');          // the page opens on the offer
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
      document.body.classList.toggle('in-offer', Object.keys(seen).some(function (k) { return seen[k]; }));
    });
    offers.forEach(function (o) { io.observe(o); });
  })();

  /* ---------- photo viewer: the offer's photos full size, with zoom ----------
     A click (or tap) on the photo, or on the button in its corner, opens it at the photo on show. The
     arrows, the thumbnails, a swipe or the arrow keys move between photos; Esc, the x or a click beside
     the photo closes it. A click (or tap) on the photo zooms in at that spot: then the mouse looks
     around by moving (a finger by dragging), and another click zooms back out. The zoom goes as far as
     the photo's own pixels allow, between 2x and 3x. */
  (function () {
    var box = document.getElementById('lightbox'), main = document.getElementById('galMain');
    if (!box || !main) return;
    var frame = main.parentNode, stage = document.getElementById('lbxStage'), img = document.getElementById('lbxImg');
    var count = document.getElementById('lbxCount'), hint = document.getElementById('lbxHint'), strip = document.getElementById('lbxThumbs');
    var srcs = [].map.call(document.querySelectorAll('#galThumbs button'), function (b) { return b.getAttribute('data-src'); });
    if (!srcs.length) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var words = { idle: touch ? 'Tap to zoom, swipe for more' : 'Click to zoom',
                  zoomed: touch ? 'Drag to look around, tap to zoom out' : 'Move to look around, click to zoom out' };
    var at = 0, zoomed = false, Z = 2, ox = 0.5, oy = 0.5, lastFocus = null, down = null, skipUntil = 0;
    var clamp = function (v) { return isFinite(v) ? Math.max(0, Math.min(1, v)) : 0.5; };
    var origin = function (x, y) { ox = x; oy = y; img.style.transformOrigin = (x * 100).toFixed(2) + '% ' + (y * 100).toFixed(2) + '%'; };
    var zoom = function (on, x, y) {
      if (on && !img.offsetWidth) return;             // the photo is still loading
      zoomed = on;
      box.classList.toggle('zoomed', on);
      if (on) {
        Z = Math.min(3, Math.max(2, (img.naturalWidth || 1200) / img.offsetWidth));
        origin(x, y);
        img.style.transform = 'scale(' + Z.toFixed(3) + ')';
      } else img.style.transform = '';
      hint.textContent = on ? words.zoomed : words.idle;
    };
    var show = function (n) {
      at = (n + srcs.length) % srcs.length;
      zoom(false);
      // the photo on show stays until the next one has loaded, then it is swapped in
      var want = srcs[at], next = new Image();
      next.onload = next.onerror = function () { if (srcs[at] === want) img.src = want; };
      next.src = want;
      img.alt = 'Innova 5610, photo ' + (at + 1) + ' of ' + srcs.length;
      count.textContent = (at + 1) + ' / ' + srcs.length;
      [].forEach.call(strip.children, function (b, k) { b.classList.toggle('on', k === at); });
      [at + 1, at - 1].forEach(function (k) { var p = new Image(); p.src = srcs[(k + srcs.length) % srcs.length]; });
    };
    srcs.forEach(function (src, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (n + 1));
      var t = document.createElement('img'); t.src = src; t.alt = '';
      b.appendChild(t);
      b.addEventListener('click', function () { show(n); });
      strip.appendChild(b);
    });
    var open = function (src) {
      var n = srcs.indexOf(typeof src === 'string' ? src : main.getAttribute('src'));
      lastFocus = document.activeElement;
      box.classList.add('open');
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      show(n < 0 ? 0 : n);
      box.querySelector('.lbx-x').focus();
    };
    var close = function () {
      box.classList.remove('open');
      box.setAttribute('aria-hidden', 'true');
      zoom(false);
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    frame.addEventListener('click', function (e) { if (!e.target.closest('.go-gift')) open(); });
    // the repeated offer near the end: its photo opens the viewer at the photo it shows
    document.addEventListener('click', function (e) {
      var m = e.target.closest && e.target.closest('#buyBottom .gal .main');
      if (!m || e.target.closest('.go-gift')) return;
      open(m.querySelector('img').getAttribute('src'));
    });
    box.querySelectorAll('[data-lbx-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.getElementById('lbxPrev').addEventListener('click', function () { show(at - 1); });
    document.getElementById('lbxNext').addEventListener('click', function () { show(at + 1); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(at + 1);
      else if (e.key === 'ArrowLeft') show(at - 1);
    });
    // the page behind must not scroll while the viewer is open
    box.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
    box.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    stage.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, ox: ox, oy: oy, type: e.pointerType, moved: false };
    });
    stage.addEventListener('pointermove', function (e) {
      if (zoomed && e.pointerType === 'mouse') {      // a mouse looks around just by moving
        var sr = stage.getBoundingClientRect();
        origin(clamp((e.clientX - sr.left - img.offsetLeft) / img.offsetWidth), clamp((e.clientY - sr.top - img.offsetTop) / img.offsetHeight));
        return;
      }
      if (!down || down.type === 'mouse') return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) down.moved = true;
      // a finger drags the zoomed photo along with it
      if (zoomed) origin(clamp(down.ox - dx / ((Z - 1) * img.offsetWidth)), clamp(down.oy - dy / ((Z - 1) * img.offsetHeight)));
    });
    stage.addEventListener('pointerup', function (e) {
      var d = down; down = null;
      if (!d || d.type === 'mouse') return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(at + (dx < 0 ? 1 : -1));   // a swipe
      if (d.moved || Math.abs(dx) + Math.abs(dy) > 8) skipUntil = Date.now() + 300;   // a click right after is part of the gesture
    });
    stage.addEventListener('pointercancel', function () { down = null; });
    stage.addEventListener('click', function (e) {
      if (Date.now() < skipUntil) return;
      if (e.target !== img) { close(); return; }      // beside the photo
      if (zoomed) { zoom(false); return; }
      var r = img.getBoundingClientRect();
      zoom(true, clamp((e.clientX - r.left) / r.width), clamp((e.clientY - r.top) / r.height));
    });
    hint.textContent = words.idle;
  })();

  /* ---------- the offer, repeated near the end (the user's request, Oct 14, 2026: "just do a repeat of the
     main offer") ----------
     #buyBottom holds a copy of the offer at the top, rebuilt from it whenever that offer changes, so the two
     can never disagree. The copy has no ids and no radio names, so the page keeps one set of controls: its
     gift picks, its flash/gift tabs and its Learn more buttons act on the offer at the top (which then
     rebuilds the copy); its buy buttons open the cart (with the other buy buttons, further up); its CarMD
     picture opens the CarMD window and its photo the photo viewer. Its gallery and its Description panels
     work on their own. */
  (function () {
    var top = document.getElementById('buy'), box = document.getElementById('buyBottom');
    if (!top || !box) return;
    var photo = null, openPanel = -1;                 // the copy's own gallery photo and open panel, kept across rebuilds
    var showPhoto = function (s) {
      var main = box.querySelector('.gal .main'), img = main && main.querySelector('img'), btns = box.querySelectorAll('.thumbs button');
      if (!img || !btns.length) return;
      img.setAttribute('src', s);
      [].forEach.call(btns, function (b) { b.classList.toggle('on', b.getAttribute('data-src') === s); });
      main.classList.toggle('is-alt', s !== btns[0].getAttribute('data-src'));
    };
    var build = function () {
      var copy = top.querySelector('.wrap').cloneNode(true);
      [].forEach.call(copy.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
      [].forEach.call(copy.querySelectorAll('label[for]'), function (el) { el.setAttribute('data-for', el.getAttribute('for')); el.removeAttribute('for'); });
      [].forEach.call(copy.querySelectorAll('input[type="radio"]'), function (el) { el.removeAttribute('name'); el.tabIndex = -1; });
      [].forEach.call(copy.querySelectorAll('.dp-mail[data-place]'), function (el) { el.setAttribute('data-place', 'offer-bottom'); });
      [].forEach.call(copy.querySelectorAll('[aria-labelledby]'), function (el) { el.removeAttribute('aria-labelledby'); });
      // Shopify's installments note draws itself; let the copy's draw afresh rather than keep a drawn copy
      [].forEach.call(copy.querySelectorAll('shopify-payment-terms'), function (el) { el.innerHTML = ''; });
      box.textContent = '';
      box.appendChild(copy);
      if (photo) showPhoto(photo);
      var its = box.querySelectorAll('.acc .it');
      [].forEach.call(its, function (x, k) {
        x.classList.toggle('open', k === openPanel);
        x.querySelector('.a').style.maxHeight = k === openPanel ? x.querySelector('.a').scrollHeight + 'px' : null;
      });
    };
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.pick') && !t.closest('.pick-more')) {         // a gift: pick it in the offer at the top
        e.preventDefault();
        var lab = t.closest('.pick').querySelector('[data-for]'), input = lab && document.getElementById(lab.getAttribute('data-for'));
        if (input && !input.disabled && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      var more = t.closest('.pick-more');
      if (more) { var orig = top.querySelector('.pick-more[data-gift-info="' + more.getAttribute('data-gift-info') + '"]'); if (orig) orig.click(); return; }
      var tab = t.closest('[data-offer]');
      if (tab) { var o = top.querySelector('[data-offer="' + tab.getAttribute('data-offer') + '"]'); if (o) o.click(); return; }
      if (t.closest('.gift .l')) { var cam = document.getElementById('cam3360Open'); if (cam) cam.click(); return; }
      var gift = t.closest('.go-gift');
      if (gift) { if (gift.classList.contains('is-carmd')) { e.stopPropagation(); document.dispatchEvent(new CustomEvent('carmd:window')); } return; }
      var th = t.closest('.thumbs button');
      if (th) { photo = th.getAttribute('data-src'); showPhoto(photo); return; }
      var q = t.closest('.acc .q');
      if (q) {
        var item = q.closest('.it'), isOpen = item.classList.contains('open');
        [].forEach.call(item.parentNode.querySelectorAll('.it.open'), function (x) { x.classList.remove('open'); x.querySelector('.a').style.maxHeight = null; });
        if (!isOpen) { item.classList.add('open'); var a = item.querySelector('.a'); a.style.maxHeight = a.scrollHeight + 'px'; }
        openPanel = isOpen ? -1 : [].indexOf.call(item.parentNode.querySelectorAll('.it'), item);
      }
    });
    var raf = 0;
    // the stock counter at the top ticks every few seconds: copy just that, rather than rebuild for it
    var inStock = function (m) { var n = m.target.nodeType === 1 ? m.target : m.target.parentNode; return !!(n && n.closest && n.closest('.scarcity')); };
    var copyStock = function () {
      var left = document.getElementById('stockLeft'), fill = document.getElementById('scarFill');
      var b = box.querySelector('.scar-label b'), f = box.querySelector('.scar-fill');
      if (left && b) b.textContent = left.textContent;
      if (fill && f) f.style.width = fill.style.width;
    };
    if (window.MutationObserver) new MutationObserver(function (list) {
      if (list.every(inStock)) { copyStock(); return; }
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; build(); });
    }).observe(top, { subtree: true, childList: true, characterData: true, attributes: true });
    build();
  })();
})();
